function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var append_1;
var hasRequiredAppend;
function requireAppend() {
  if (hasRequiredAppend) return append_1;
  hasRequiredAppend = 1;
  function append2(arr1, arr2) {
    if (arr2 == null) {
      return arr1;
    }
    var pad2 = arr1.length, i = -1, len = arr2.length;
    while (++i < len) {
      arr1[pad2 + i] = arr2[i];
    }
    return arr1;
  }
  append_1 = append2;
  return append_1;
}
var appendExports = requireAppend();
const append = /* @__PURE__ */ getDefaultExportFromCjs(appendExports);
var identity_1;
var hasRequiredIdentity;
function requireIdentity() {
  if (hasRequiredIdentity) return identity_1;
  hasRequiredIdentity = 1;
  function identity2(val) {
    return val;
  }
  identity_1 = identity2;
  return identity_1;
}
var prop_1;
var hasRequiredProp;
function requireProp() {
  if (hasRequiredProp) return prop_1;
  hasRequiredProp = 1;
  function prop2(name) {
    return function(obj) {
      return obj[name];
    };
  }
  prop_1 = prop2;
  return prop_1;
}
var hasOwn_1;
var hasRequiredHasOwn;
function requireHasOwn() {
  if (hasRequiredHasOwn) return hasOwn_1;
  hasRequiredHasOwn = 1;
  function hasOwn2(obj, prop2) {
    return Object.prototype.hasOwnProperty.call(obj, prop2);
  }
  hasOwn_1 = hasOwn2;
  return hasOwn_1;
}
var forIn_1;
var hasRequiredForIn;
function requireForIn() {
  if (hasRequiredForIn) return forIn_1;
  hasRequiredForIn = 1;
  var hasOwn2 = requireHasOwn();
  var _hasDontEnumBug, _dontEnums;
  function checkDontEnum() {
    _dontEnums = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ];
    _hasDontEnumBug = true;
    for (var key in { "toString": null }) {
      _hasDontEnumBug = false;
    }
  }
  function forIn2(obj, fn, thisObj) {
    var key, i = 0;
    if (_hasDontEnumBug == null) checkDontEnum();
    for (key in obj) {
      if (exec(fn, obj, key, thisObj) === false) {
        break;
      }
    }
    if (_hasDontEnumBug) {
      var ctor = obj.constructor, isProto = !!ctor && obj === ctor.prototype;
      while (key = _dontEnums[i++]) {
        if ((key !== "constructor" || !isProto && hasOwn2(obj, key)) && obj[key] !== Object.prototype[key]) {
          if (exec(fn, obj, key, thisObj) === false) {
            break;
          }
        }
      }
    }
  }
  function exec(fn, obj, key, thisObj) {
    return fn.call(thisObj, obj[key], key, obj);
  }
  forIn_1 = forIn2;
  return forIn_1;
}
var forOwn_1;
var hasRequiredForOwn;
function requireForOwn() {
  if (hasRequiredForOwn) return forOwn_1;
  hasRequiredForOwn = 1;
  var hasOwn2 = requireHasOwn();
  var forIn2 = requireForIn();
  function forOwn2(obj, fn, thisObj) {
    forIn2(obj, function(val, key) {
      if (hasOwn2(obj, key)) {
        return fn.call(thisObj, obj[key], key, obj);
      }
    });
  }
  forOwn_1 = forOwn2;
  return forOwn_1;
}
var kindOf_1;
var hasRequiredKindOf;
function requireKindOf() {
  if (hasRequiredKindOf) return kindOf_1;
  hasRequiredKindOf = 1;
  function kindOf2(val) {
    return Object.prototype.toString.call(val).slice(8, -1);
  }
  kindOf_1 = kindOf2;
  return kindOf_1;
}
var isKind_1;
var hasRequiredIsKind;
function requireIsKind() {
  if (hasRequiredIsKind) return isKind_1;
  hasRequiredIsKind = 1;
  var kindOf2 = requireKindOf();
  function isKind2(val, kind) {
    return kindOf2(val) === kind;
  }
  isKind_1 = isKind2;
  return isKind_1;
}
var isArray_1;
var hasRequiredIsArray;
function requireIsArray() {
  if (hasRequiredIsArray) return isArray_1;
  hasRequiredIsArray = 1;
  var isKind2 = requireIsKind();
  var isArray2 = Array.isArray || function(val) {
    return isKind2(val, "Array");
  };
  isArray_1 = isArray2;
  return isArray_1;
}
var deepMatches_1;
var hasRequiredDeepMatches;
function requireDeepMatches() {
  if (hasRequiredDeepMatches) return deepMatches_1;
  hasRequiredDeepMatches = 1;
  var forOwn2 = requireForOwn();
  var isArray2 = requireIsArray();
  function containsMatch(array, pattern) {
    var i = -1, length = array.length;
    while (++i < length) {
      if (deepMatches2(array[i], pattern)) {
        return true;
      }
    }
    return false;
  }
  function matchArray(target, pattern) {
    var i = -1, patternLength = pattern.length;
    while (++i < patternLength) {
      if (!containsMatch(target, pattern[i])) {
        return false;
      }
    }
    return true;
  }
  function matchObject(target, pattern) {
    var result2 = true;
    forOwn2(pattern, function(val, key) {
      if (!deepMatches2(target[key], val)) {
        return result2 = false;
      }
    });
    return result2;
  }
  function deepMatches2(target, pattern) {
    if (target && typeof target === "object" && pattern && typeof pattern === "object") {
      if (isArray2(target) && isArray2(pattern)) {
        return matchArray(target, pattern);
      } else {
        return matchObject(target, pattern);
      }
    } else {
      return target === pattern;
    }
  }
  deepMatches_1 = deepMatches2;
  return deepMatches_1;
}
var makeIterator_;
var hasRequiredMakeIterator_;
function requireMakeIterator_() {
  if (hasRequiredMakeIterator_) return makeIterator_;
  hasRequiredMakeIterator_ = 1;
  var identity2 = requireIdentity();
  var prop2 = requireProp();
  var deepMatches2 = requireDeepMatches();
  function makeIterator(src, thisObj) {
    if (src == null) {
      return identity2;
    }
    switch (typeof src) {
      case "function":
        return typeof thisObj !== "undefined" ? function(val, i, arr) {
          return src.call(thisObj, val, i, arr);
        } : src;
      case "object":
        return function(val) {
          return deepMatches2(val, src);
        };
      case "string":
      case "number":
        return prop2(src);
    }
  }
  makeIterator_ = makeIterator;
  return makeIterator_;
}
var collect_1;
var hasRequiredCollect;
function requireCollect() {
  if (hasRequiredCollect) return collect_1;
  hasRequiredCollect = 1;
  var append2 = requireAppend();
  var makeIterator = requireMakeIterator_();
  function collect2(arr, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var results = [];
    if (arr == null) {
      return results;
    }
    var i = -1, len = arr.length;
    while (++i < len) {
      var value = callback(arr[i], i, arr);
      if (value != null) {
        append2(results, value);
      }
    }
    return results;
  }
  collect_1 = collect2;
  return collect_1;
}
var collectExports = requireCollect();
const collect = /* @__PURE__ */ getDefaultExportFromCjs(collectExports);
var indexOf_1;
var hasRequiredIndexOf;
function requireIndexOf() {
  if (hasRequiredIndexOf) return indexOf_1;
  hasRequiredIndexOf = 1;
  function indexOf2(arr, item, fromIndex) {
    fromIndex = fromIndex || 0;
    if (arr == null) {
      return -1;
    }
    var len = arr.length, i = fromIndex < 0 ? len + fromIndex : fromIndex;
    while (i < len) {
      if (arr[i] === item) {
        return i;
      }
      i++;
    }
    return -1;
  }
  indexOf_1 = indexOf2;
  return indexOf_1;
}
var combine_1;
var hasRequiredCombine;
function requireCombine() {
  if (hasRequiredCombine) return combine_1;
  hasRequiredCombine = 1;
  var indexOf2 = requireIndexOf();
  function combine2(arr1, arr2) {
    if (arr2 == null) {
      return arr1;
    }
    var i = -1, len = arr2.length;
    while (++i < len) {
      if (indexOf2(arr1, arr2[i]) === -1) {
        arr1.push(arr2[i]);
      }
    }
    return arr1;
  }
  combine_1 = combine2;
  return combine_1;
}
var combineExports = requireCombine();
const combine = /* @__PURE__ */ getDefaultExportFromCjs(combineExports);
var filter_1$1;
var hasRequiredFilter$2;
function requireFilter$2() {
  if (hasRequiredFilter$2) return filter_1$1;
  hasRequiredFilter$2 = 1;
  var makeIterator = requireMakeIterator_();
  function filter2(arr, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var results = [];
    if (arr == null) {
      return results;
    }
    var i = -1, len = arr.length, value;
    while (++i < len) {
      value = arr[i];
      if (callback(value, i, arr)) {
        results.push(value);
      }
    }
    return results;
  }
  filter_1$1 = filter2;
  return filter_1$1;
}
var compact_1;
var hasRequiredCompact;
function requireCompact() {
  if (hasRequiredCompact) return compact_1;
  hasRequiredCompact = 1;
  var filter2 = requireFilter$2();
  function compact2(arr) {
    return filter2(arr, function(val) {
      return val != null;
    });
  }
  compact_1 = compact2;
  return compact_1;
}
var compactExports = requireCompact();
const compact = /* @__PURE__ */ getDefaultExportFromCjs(compactExports);
var contains_1$3;
var hasRequiredContains$4;
function requireContains$4() {
  if (hasRequiredContains$4) return contains_1$3;
  hasRequiredContains$4 = 1;
  var indexOf2 = requireIndexOf();
  function contains2(arr, val) {
    return indexOf2(arr, val) !== -1;
  }
  contains_1$3 = contains2;
  return contains_1$3;
}
var containsExports$4 = requireContains$4();
const contains$5 = /* @__PURE__ */ getDefaultExportFromCjs(containsExports$4);
var unique_1;
var hasRequiredUnique;
function requireUnique() {
  if (hasRequiredUnique) return unique_1;
  hasRequiredUnique = 1;
  var filter2 = requireFilter$2();
  function unique2(arr, compare) {
    compare = compare || isEqual;
    return filter2(arr, function(item, i, arr2) {
      var n2 = arr2.length;
      while (++i < n2) {
        if (compare(item, arr2[i])) {
          return false;
        }
      }
      return true;
    });
  }
  function isEqual(a, b) {
    return a === b;
  }
  unique_1 = unique2;
  return unique_1;
}
var some_1$1;
var hasRequiredSome$2;
function requireSome$2() {
  if (hasRequiredSome$2) return some_1$1;
  hasRequiredSome$2 = 1;
  var makeIterator = requireMakeIterator_();
  function some2(arr, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var result2 = false;
    if (arr == null) {
      return result2;
    }
    var i = -1, len = arr.length;
    while (++i < len) {
      if (callback(arr[i], i, arr)) {
        result2 = true;
        break;
      }
    }
    return result2;
  }
  some_1$1 = some2;
  return some_1$1;
}
var slice_1;
var hasRequiredSlice;
function requireSlice() {
  if (hasRequiredSlice) return slice_1;
  hasRequiredSlice = 1;
  function slice2(arr, start, end) {
    var len = arr.length;
    if (start == null) {
      start = 0;
    } else if (start < 0) {
      start = Math.max(len + start, 0);
    } else {
      start = Math.min(start, len);
    }
    if (end == null) {
      end = len;
    } else if (end < 0) {
      end = Math.max(len + end, 0);
    } else {
      end = Math.min(end, len);
    }
    var result2 = [];
    while (start < end) {
      result2.push(arr[start++]);
    }
    return result2;
  }
  slice_1 = slice2;
  return slice_1;
}
var difference_1;
var hasRequiredDifference;
function requireDifference() {
  if (hasRequiredDifference) return difference_1;
  hasRequiredDifference = 1;
  var unique2 = requireUnique();
  var filter2 = requireFilter$2();
  var some2 = requireSome$2();
  var contains2 = requireContains$4();
  var slice2 = requireSlice();
  function difference2(arr) {
    var arrs = slice2(arguments, 1), result2 = filter2(unique2(arr), function(needle) {
      return !some2(arrs, function(haystack) {
        return contains2(haystack, needle);
      });
    });
    return result2;
  }
  difference_1 = difference2;
  return difference_1;
}
var differenceExports = requireDifference();
const difference = /* @__PURE__ */ getDefaultExportFromCjs(differenceExports);
var is_1;
var hasRequiredIs;
function requireIs() {
  if (hasRequiredIs) return is_1;
  hasRequiredIs = 1;
  function is2(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    }
    return x !== x && y !== y;
  }
  is_1 = is2;
  return is_1;
}
var every_1$1;
var hasRequiredEvery$2;
function requireEvery$2() {
  if (hasRequiredEvery$2) return every_1$1;
  hasRequiredEvery$2 = 1;
  var makeIterator = requireMakeIterator_();
  function every2(arr, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var result2 = true;
    if (arr == null) {
      return result2;
    }
    var i = -1, len = arr.length;
    while (++i < len) {
      if (!callback(arr[i], i, arr)) {
        result2 = false;
        break;
      }
    }
    return result2;
  }
  every_1$1 = every2;
  return every_1$1;
}
var equals_1$1;
var hasRequiredEquals$1;
function requireEquals$1() {
  if (hasRequiredEquals$1) return equals_1$1;
  hasRequiredEquals$1 = 1;
  var is2 = requireIs();
  var isArray2 = requireIsArray();
  var every2 = requireEvery$2();
  function equals2(a, b, callback) {
    callback = callback || is2;
    if (!isArray2(a) || !isArray2(b)) {
      return callback(a, b);
    }
    if (a.length !== b.length) {
      return false;
    }
    return every2(a, makeCompare(callback), b);
  }
  function makeCompare(callback) {
    return function(value, i) {
      return i in this && callback(value, this[i]);
    };
  }
  equals_1$1 = equals2;
  return equals_1$1;
}
var equalsExports$1 = requireEquals$1();
const equals$1 = /* @__PURE__ */ getDefaultExportFromCjs(equalsExports$1);
var everyExports$2 = requireEvery$2();
const every$3 = /* @__PURE__ */ getDefaultExportFromCjs(everyExports$2);
var filterExports$2 = requireFilter$2();
const filter$3 = /* @__PURE__ */ getDefaultExportFromCjs(filterExports$2);
var findIndex_1;
var hasRequiredFindIndex;
function requireFindIndex() {
  if (hasRequiredFindIndex) return findIndex_1;
  hasRequiredFindIndex = 1;
  var makeIterator = requireMakeIterator_();
  function findIndex2(arr, iterator, thisObj) {
    iterator = makeIterator(iterator, thisObj);
    if (arr == null) {
      return -1;
    }
    var i = -1, len = arr.length;
    while (++i < len) {
      if (iterator(arr[i], i, arr)) {
        return i;
      }
    }
    return -1;
  }
  findIndex_1 = findIndex2;
  return findIndex_1;
}
var find_1$1;
var hasRequiredFind$2;
function requireFind$2() {
  if (hasRequiredFind$2) return find_1$1;
  hasRequiredFind$2 = 1;
  var findIndex2 = requireFindIndex();
  function find2(arr, iterator, thisObj) {
    var idx = findIndex2(arr, iterator, thisObj);
    return idx >= 0 ? arr[idx] : void 0;
  }
  find_1$1 = find2;
  return find_1$1;
}
var findExports$2 = requireFind$2();
const find$3 = /* @__PURE__ */ getDefaultExportFromCjs(findExports$2);
var findLastIndex_1;
var hasRequiredFindLastIndex;
function requireFindLastIndex() {
  if (hasRequiredFindLastIndex) return findLastIndex_1;
  hasRequiredFindLastIndex = 1;
  var makeIterator = requireMakeIterator_();
  function findLastIndex2(arr, iterator, thisObj) {
    iterator = makeIterator(iterator, thisObj);
    if (arr == null) {
      return -1;
    }
    var n2 = arr.length;
    while (--n2 >= 0) {
      if (iterator(arr[n2], n2, arr)) {
        return n2;
      }
    }
    return -1;
  }
  findLastIndex_1 = findLastIndex2;
  return findLastIndex_1;
}
var findLast_1;
var hasRequiredFindLast;
function requireFindLast() {
  if (hasRequiredFindLast) return findLast_1;
  hasRequiredFindLast = 1;
  var findLastIndex2 = requireFindLastIndex();
  function findLast2(arr, iterator, thisObj) {
    var idx = findLastIndex2(arr, iterator, thisObj);
    return idx >= 0 ? arr[idx] : void 0;
  }
  findLast_1 = findLast2;
  return findLast_1;
}
var findLastExports = requireFindLast();
const findLast = /* @__PURE__ */ getDefaultExportFromCjs(findLastExports);
var findIndexExports = requireFindIndex();
const findIndex = /* @__PURE__ */ getDefaultExportFromCjs(findIndexExports);
var findLastIndexExports = requireFindLastIndex();
const findLastIndex = /* @__PURE__ */ getDefaultExportFromCjs(findLastIndexExports);
var flatten_1;
var hasRequiredFlatten;
function requireFlatten() {
  if (hasRequiredFlatten) return flatten_1;
  hasRequiredFlatten = 1;
  var isArray2 = requireIsArray();
  var append2 = requireAppend();
  function flattenTo(arr, result2, level) {
    if (level === 0) {
      append2(result2, arr);
      return result2;
    }
    var value, i = -1, len = arr.length;
    while (++i < len) {
      value = arr[i];
      if (isArray2(value)) {
        flattenTo(value, result2, level - 1);
      } else {
        result2.push(value);
      }
    }
    return result2;
  }
  function flatten2(arr, level) {
    if (arr == null) {
      return [];
    }
    level = level == null ? -1 : level;
    return flattenTo(arr, [], level);
  }
  flatten_1 = flatten2;
  return flatten_1;
}
var flattenExports = requireFlatten();
const flatten = /* @__PURE__ */ getDefaultExportFromCjs(flattenExports);
var forEach_1;
var hasRequiredForEach$1;
function requireForEach$1() {
  if (hasRequiredForEach$1) return forEach_1;
  hasRequiredForEach$1 = 1;
  function forEach2(arr, callback, thisObj) {
    if (arr == null) {
      return;
    }
    var i = -1, len = arr.length;
    while (++i < len) {
      if (callback.call(thisObj, arr[i], i, arr) === false) {
        break;
      }
    }
  }
  forEach_1 = forEach2;
  return forEach_1;
}
var forEachExports$1 = requireForEach$1();
const forEach$2 = /* @__PURE__ */ getDefaultExportFromCjs(forEachExports$1);
var groupBy_1;
var hasRequiredGroupBy;
function requireGroupBy() {
  if (hasRequiredGroupBy) return groupBy_1;
  hasRequiredGroupBy = 1;
  var forEach2 = requireForEach$1();
  var identity2 = requireIdentity();
  var makeIterator = requireMakeIterator_();
  function groupBy2(arr, categorize, thisObj) {
    if (categorize) {
      categorize = makeIterator(categorize, thisObj);
    } else {
      categorize = identity2;
    }
    var buckets = {};
    forEach2(arr, function(element) {
      var bucket = categorize(element);
      if (!(bucket in buckets)) {
        buckets[bucket] = [];
      }
      buckets[bucket].push(element);
    });
    return buckets;
  }
  groupBy_1 = groupBy2;
  return groupBy_1;
}
var groupByExports = requireGroupBy();
const groupBy = /* @__PURE__ */ getDefaultExportFromCjs(groupByExports);
var indexOfExports = requireIndexOf();
const indexOf = /* @__PURE__ */ getDefaultExportFromCjs(indexOfExports);
var insert_1$1;
var hasRequiredInsert$1;
function requireInsert$1() {
  if (hasRequiredInsert$1) return insert_1$1;
  hasRequiredInsert$1 = 1;
  var difference2 = requireDifference();
  var slice2 = requireSlice();
  function insert2(arr, rest_items) {
    var diff2 = difference2(slice2(arguments, 1), arr);
    if (diff2.length) {
      Array.prototype.push.apply(arr, diff2);
    }
    return arr.length;
  }
  insert_1$1 = insert2;
  return insert_1$1;
}
var insertExports$1 = requireInsert$1();
const insert$1 = /* @__PURE__ */ getDefaultExportFromCjs(insertExports$1);
var intersection_1;
var hasRequiredIntersection;
function requireIntersection() {
  if (hasRequiredIntersection) return intersection_1;
  hasRequiredIntersection = 1;
  var unique2 = requireUnique();
  var filter2 = requireFilter$2();
  var every2 = requireEvery$2();
  var contains2 = requireContains$4();
  var slice2 = requireSlice();
  function intersection2(arr) {
    var arrs = slice2(arguments, 1), result2 = filter2(unique2(arr), function(needle) {
      return every2(arrs, function(haystack) {
        return contains2(haystack, needle);
      });
    });
    return result2;
  }
  intersection_1 = intersection2;
  return intersection_1;
}
var intersectionExports = requireIntersection();
const intersection = /* @__PURE__ */ getDefaultExportFromCjs(intersectionExports);
var invoke_1;
var hasRequiredInvoke;
function requireInvoke() {
  if (hasRequiredInvoke) return invoke_1;
  hasRequiredInvoke = 1;
  var slice2 = requireSlice();
  function invoke2(arr, methodName, var_args) {
    if (arr == null) {
      return arr;
    }
    var args = slice2(arguments, 2);
    var i = -1, len = arr.length, value;
    while (++i < len) {
      value = arr[i];
      value[methodName].apply(value, args);
    }
    return arr;
  }
  invoke_1 = invoke2;
  return invoke_1;
}
var invokeExports = requireInvoke();
const invoke = /* @__PURE__ */ getDefaultExportFromCjs(invokeExports);
var join_1;
var hasRequiredJoin;
function requireJoin() {
  if (hasRequiredJoin) return join_1;
  hasRequiredJoin = 1;
  var filter2 = requireFilter$2();
  function isValidString(val) {
    return val != null && val !== "";
  }
  function join2(items, separator) {
    separator = separator || "";
    return filter2(items, isValidString).join(separator);
  }
  join_1 = join2;
  return join_1;
}
var joinExports = requireJoin();
const join = /* @__PURE__ */ getDefaultExportFromCjs(joinExports);
var last_1;
var hasRequiredLast;
function requireLast() {
  if (hasRequiredLast) return last_1;
  hasRequiredLast = 1;
  function last2(arr) {
    if (arr == null || arr.length < 1) {
      return void 0;
    }
    return arr[arr.length - 1];
  }
  last_1 = last2;
  return last_1;
}
var lastExports = requireLast();
const last = /* @__PURE__ */ getDefaultExportFromCjs(lastExports);
var lastIndexOf_1;
var hasRequiredLastIndexOf;
function requireLastIndexOf() {
  if (hasRequiredLastIndexOf) return lastIndexOf_1;
  hasRequiredLastIndexOf = 1;
  function lastIndexOf2(arr, item, fromIndex) {
    if (arr == null) {
      return -1;
    }
    var len = arr.length;
    fromIndex = fromIndex == null || fromIndex >= len ? len - 1 : fromIndex;
    fromIndex = fromIndex < 0 ? len + fromIndex : fromIndex;
    while (fromIndex >= 0) {
      if (arr[fromIndex] === item) {
        return fromIndex;
      }
      fromIndex--;
    }
    return -1;
  }
  lastIndexOf_1 = lastIndexOf2;
  return lastIndexOf_1;
}
var lastIndexOfExports = requireLastIndexOf();
const lastIndexOf = /* @__PURE__ */ getDefaultExportFromCjs(lastIndexOfExports);
var map_1$2;
var hasRequiredMap$3;
function requireMap$3() {
  if (hasRequiredMap$3) return map_1$2;
  hasRequiredMap$3 = 1;
  var makeIterator = requireMakeIterator_();
  function map2(arr, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var results = [];
    if (arr == null) {
      return results;
    }
    var i = -1, len = arr.length;
    while (++i < len) {
      results[i] = callback(arr[i], i, arr);
    }
    return results;
  }
  map_1$2 = map2;
  return map_1$2;
}
var mapExports$3 = requireMap$3();
const map$4 = /* @__PURE__ */ getDefaultExportFromCjs(mapExports$3);
var max_1$1;
var hasRequiredMax$2;
function requireMax$2() {
  if (hasRequiredMax$2) return max_1$1;
  hasRequiredMax$2 = 1;
  var makeIterator = requireMakeIterator_();
  function max2(arr, iterator, thisObj) {
    if (arr == null || !arr.length) {
      return Infinity;
    } else if (arr.length && !iterator) {
      return Math.max.apply(Math, arr);
    } else {
      iterator = makeIterator(iterator, thisObj);
      var result2, compare = -Infinity, value, temp;
      var i = -1, len = arr.length;
      while (++i < len) {
        value = arr[i];
        temp = iterator(value, i, arr);
        if (temp > compare) {
          compare = temp;
          result2 = value;
        }
      }
      return result2;
    }
  }
  max_1$1 = max2;
  return max_1$1;
}
var maxExports$2 = requireMax$2();
const max$3 = /* @__PURE__ */ getDefaultExportFromCjs(maxExports$2);
var min_1$1;
var hasRequiredMin$2;
function requireMin$2() {
  if (hasRequiredMin$2) return min_1$1;
  hasRequiredMin$2 = 1;
  var makeIterator = requireMakeIterator_();
  function min2(arr, iterator, thisObj) {
    if (arr == null || !arr.length) {
      return -Infinity;
    } else if (arr.length && !iterator) {
      return Math.min.apply(Math, arr);
    } else {
      iterator = makeIterator(iterator, thisObj);
      var result2, compare = Infinity, value, temp;
      var i = -1, len = arr.length;
      while (++i < len) {
        value = arr[i];
        temp = iterator(value, i, arr);
        if (temp < compare) {
          compare = temp;
          result2 = value;
        }
      }
      return result2;
    }
  }
  min_1$1 = min2;
  return min_1$1;
}
var minExports$2 = requireMin$2();
const min$3 = /* @__PURE__ */ getDefaultExportFromCjs(minExports$2);
var MIN_INT$1;
var hasRequiredMIN_INT;
function requireMIN_INT() {
  if (hasRequiredMIN_INT) return MIN_INT$1;
  hasRequiredMIN_INT = 1;
  MIN_INT$1 = -2147483648;
  return MIN_INT$1;
}
var MAX_INT$1;
var hasRequiredMAX_INT;
function requireMAX_INT() {
  if (hasRequiredMAX_INT) return MAX_INT$1;
  hasRequiredMAX_INT = 1;
  MAX_INT$1 = 2147483647;
  return MAX_INT$1;
}
var random_1;
var hasRequiredRandom;
function requireRandom() {
  if (hasRequiredRandom) return random_1;
  hasRequiredRandom = 1;
  function random2() {
    return random2.get();
  }
  random2.get = Math.random;
  random_1 = random2;
  return random_1;
}
var rand_1;
var hasRequiredRand;
function requireRand() {
  if (hasRequiredRand) return rand_1;
  hasRequiredRand = 1;
  var random2 = requireRandom();
  var MIN_INT2 = requireMIN_INT();
  var MAX_INT2 = requireMAX_INT();
  function rand2(min2, max2) {
    min2 = min2 == null ? MIN_INT2 : min2;
    max2 = max2 == null ? MAX_INT2 : max2;
    return min2 + (max2 - min2) * random2();
  }
  rand_1 = rand2;
  return rand_1;
}
var randInt_1;
var hasRequiredRandInt;
function requireRandInt() {
  if (hasRequiredRandInt) return randInt_1;
  hasRequiredRandInt = 1;
  var MIN_INT2 = requireMIN_INT();
  var MAX_INT2 = requireMAX_INT();
  var rand2 = requireRand();
  function randInt2(min2, max2) {
    min2 = min2 == null ? MIN_INT2 : ~~min2;
    max2 = max2 == null ? MAX_INT2 : ~~max2;
    return Math.round(rand2(min2 - 0.5, max2 + 0.499999999999));
  }
  randInt_1 = randInt2;
  return randInt_1;
}
var pick_1$1;
var hasRequiredPick$1;
function requirePick$1() {
  if (hasRequiredPick$1) return pick_1$1;
  hasRequiredPick$1 = 1;
  var randInt2 = requireRandInt();
  function pick2(arr, nItems) {
    if (nItems != null) {
      var result2 = [];
      if (nItems > 0 && arr && arr.length) {
        nItems = nItems > arr.length ? arr.length : nItems;
        while (nItems--) {
          result2.push(pickOne(arr));
        }
      }
      return result2;
    }
    return arr && arr.length ? pickOne(arr) : void 0;
  }
  function pickOne(arr) {
    var idx = randInt2(0, arr.length - 1);
    return arr.splice(idx, 1)[0];
  }
  pick_1$1 = pick2;
  return pick_1$1;
}
var pickExports$1 = requirePick$1();
const pick$2 = /* @__PURE__ */ getDefaultExportFromCjs(pickExports$1);
var pluck_1$2;
var hasRequiredPluck$2;
function requirePluck$2() {
  if (hasRequiredPluck$2) return pluck_1$2;
  hasRequiredPluck$2 = 1;
  var map2 = requireMap$3();
  function pluck2(arr, propName) {
    return map2(arr, propName);
  }
  pluck_1$2 = pluck2;
  return pluck_1$2;
}
var pluckExports$2 = requirePluck$2();
const pluck$2 = /* @__PURE__ */ getDefaultExportFromCjs(pluckExports$2);
var countSteps_1;
var hasRequiredCountSteps;
function requireCountSteps() {
  if (hasRequiredCountSteps) return countSteps_1;
  hasRequiredCountSteps = 1;
  function countSteps2(val, step, overflow) {
    val = Math.floor(val / step);
    if (overflow) {
      return val % overflow;
    }
    return val;
  }
  countSteps_1 = countSteps2;
  return countSteps_1;
}
var range_1;
var hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range_1;
  hasRequiredRange = 1;
  var countSteps2 = requireCountSteps();
  function range2(start, stop, step) {
    if (stop == null) {
      stop = start;
      start = 0;
    }
    step = step || 1;
    var result2 = [];
    countSteps2(stop - start, step);
    var i = start;
    while (i <= stop) {
      result2.push(i);
      i += step;
    }
    return result2;
  }
  range_1 = range2;
  return range_1;
}
var rangeExports = requireRange();
const range = /* @__PURE__ */ getDefaultExportFromCjs(rangeExports);
var reduce_1$1;
var hasRequiredReduce$2;
function requireReduce$2() {
  if (hasRequiredReduce$2) return reduce_1$1;
  hasRequiredReduce$2 = 1;
  function reduce2(arr, fn, initVal) {
    var hasInit = arguments.length > 2, result2 = initVal;
    if (arr == null || !arr.length) {
      if (!hasInit) {
        throw new Error("reduce of empty array with no initial value");
      } else {
        return initVal;
      }
    }
    var i = -1, len = arr.length;
    while (++i < len) {
      if (!hasInit) {
        result2 = arr[i];
        hasInit = true;
      } else {
        result2 = fn(result2, arr[i], i, arr);
      }
    }
    return result2;
  }
  reduce_1$1 = reduce2;
  return reduce_1$1;
}
var reduceExports$2 = requireReduce$2();
const reduce$3 = /* @__PURE__ */ getDefaultExportFromCjs(reduceExports$2);
var reduceRight_1;
var hasRequiredReduceRight;
function requireReduceRight() {
  if (hasRequiredReduceRight) return reduceRight_1;
  hasRequiredReduceRight = 1;
  function reduceRight2(arr, fn, initVal) {
    var hasInit = arguments.length > 2;
    if (arr == null || !arr.length) {
      if (hasInit) {
        return initVal;
      } else {
        throw new Error("reduce of empty array with no initial value");
      }
    }
    var i = arr.length, result2 = initVal, value;
    while (--i >= 0) {
      value = arr[i];
      if (!hasInit) {
        result2 = value;
        hasInit = true;
      } else {
        result2 = fn(result2, value, i, arr);
      }
    }
    return result2;
  }
  reduceRight_1 = reduceRight2;
  return reduceRight_1;
}
var reduceRightExports = requireReduceRight();
const reduceRight = /* @__PURE__ */ getDefaultExportFromCjs(reduceRightExports);
var reject_1$2;
var hasRequiredReject$2;
function requireReject$2() {
  if (hasRequiredReject$2) return reject_1$2;
  hasRequiredReject$2 = 1;
  var makeIterator = requireMakeIterator_();
  function reject2(arr, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var results = [];
    if (arr == null) {
      return results;
    }
    var i = -1, len = arr.length, value;
    while (++i < len) {
      value = arr[i];
      if (!callback(value, i, arr)) {
        results.push(value);
      }
    }
    return results;
  }
  reject_1$2 = reject2;
  return reject_1$2;
}
var rejectExports$2 = requireReject$2();
const reject$2 = /* @__PURE__ */ getDefaultExportFromCjs(rejectExports$2);
var remove_1;
var hasRequiredRemove;
function requireRemove() {
  if (hasRequiredRemove) return remove_1;
  hasRequiredRemove = 1;
  var indexOf2 = requireIndexOf();
  function remove2(arr, item) {
    var idx = indexOf2(arr, item);
    if (idx !== -1) arr.splice(idx, 1);
  }
  remove_1 = remove2;
  return remove_1;
}
var removeExports = requireRemove();
const remove = /* @__PURE__ */ getDefaultExportFromCjs(removeExports);
var removeAll_1;
var hasRequiredRemoveAll;
function requireRemoveAll() {
  if (hasRequiredRemoveAll) return removeAll_1;
  hasRequiredRemoveAll = 1;
  var indexOf2 = requireIndexOf();
  function removeAll2(arr, item) {
    var idx = indexOf2(arr, item);
    while (idx !== -1) {
      arr.splice(idx, 1);
      idx = indexOf2(arr, item, idx);
    }
  }
  removeAll_1 = removeAll2;
  return removeAll_1;
}
var removeAllExports = requireRemoveAll();
const removeAll = /* @__PURE__ */ getDefaultExportFromCjs(removeAllExports);
var shuffle_1;
var hasRequiredShuffle;
function requireShuffle() {
  if (hasRequiredShuffle) return shuffle_1;
  hasRequiredShuffle = 1;
  var randInt2 = requireRandInt();
  function shuffle2(arr) {
    var results = [], rnd;
    if (arr == null) {
      return results;
    }
    var i = -1, len = arr.length;
    while (++i < len) {
      if (!i) {
        results[0] = arr[0];
      } else {
        rnd = randInt2(0, i);
        results[i] = results[rnd];
        results[rnd] = arr[i];
      }
    }
    return results;
  }
  shuffle_1 = shuffle2;
  return shuffle_1;
}
var shuffleExports = requireShuffle();
const shuffle = /* @__PURE__ */ getDefaultExportFromCjs(shuffleExports);
var sliceExports = requireSlice();
const slice = /* @__PURE__ */ getDefaultExportFromCjs(sliceExports);
var someExports$2 = requireSome$2();
const some$3 = /* @__PURE__ */ getDefaultExportFromCjs(someExports$2);
var sort$1;
var hasRequiredSort;
function requireSort() {
  if (hasRequiredSort) return sort$1;
  hasRequiredSort = 1;
  function mergeSort(arr, compareFn) {
    if (arr == null) {
      return [];
    } else if (arr.length < 2) {
      return arr;
    }
    if (compareFn == null) {
      compareFn = defaultCompare;
    }
    var mid, left, right;
    mid = ~~(arr.length / 2);
    left = mergeSort(arr.slice(0, mid), compareFn);
    right = mergeSort(arr.slice(mid, arr.length), compareFn);
    return merge2(left, right, compareFn);
  }
  function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function merge2(left, right, compareFn) {
    var result2 = [];
    while (left.length && right.length) {
      if (compareFn(left[0], right[0]) <= 0) {
        result2.push(left.shift());
      } else {
        result2.push(right.shift());
      }
    }
    if (left.length) {
      result2.push.apply(result2, left);
    }
    if (right.length) {
      result2.push.apply(result2, right);
    }
    return result2;
  }
  sort$1 = mergeSort;
  return sort$1;
}
var sortExports = requireSort();
const sort = /* @__PURE__ */ getDefaultExportFromCjs(sortExports);
var sortBy_1;
var hasRequiredSortBy;
function requireSortBy() {
  if (hasRequiredSortBy) return sortBy_1;
  hasRequiredSortBy = 1;
  var sort2 = requireSort();
  var makeIterator = requireMakeIterator_();
  function sortBy2(arr, callback, context) {
    callback = makeIterator(callback, context);
    return sort2(arr, function(a, b) {
      a = callback(a);
      b = callback(b);
      return a < b ? -1 : a > b ? 1 : 0;
    });
  }
  sortBy_1 = sortBy2;
  return sortBy_1;
}
var sortByExports = requireSortBy();
const sortBy = /* @__PURE__ */ getDefaultExportFromCjs(sortByExports);
var split_1;
var hasRequiredSplit;
function requireSplit() {
  if (hasRequiredSplit) return split_1;
  hasRequiredSplit = 1;
  function split2(array, segments) {
    segments = segments || 2;
    var results = [];
    if (array == null) {
      return results;
    }
    var minLength = Math.floor(array.length / segments), remainder = array.length % segments, i = 0, len = array.length, segmentIndex = 0, segmentLength;
    while (i < len) {
      segmentLength = minLength;
      if (segmentIndex < remainder) {
        segmentLength++;
      }
      results.push(array.slice(i, i + segmentLength));
      segmentIndex++;
      i += segmentLength;
    }
    return results;
  }
  split_1 = split2;
  return split_1;
}
var splitExports = requireSplit();
const split = /* @__PURE__ */ getDefaultExportFromCjs(splitExports);
var take_1;
var hasRequiredTake;
function requireTake() {
  if (hasRequiredTake) return take_1;
  hasRequiredTake = 1;
  function take2(n2, callback, thisObj) {
    var i = -1;
    var arr = [];
    if (!thisObj) {
      while (++i < n2) {
        arr[i] = callback(i, n2);
      }
    } else {
      while (++i < n2) {
        arr[i] = callback.call(thisObj, i, n2);
      }
    }
    return arr;
  }
  take_1 = take2;
  return take_1;
}
var takeExports = requireTake();
const take = /* @__PURE__ */ getDefaultExportFromCjs(takeExports);
var isFunction_1;
var hasRequiredIsFunction;
function requireIsFunction() {
  if (hasRequiredIsFunction) return isFunction_1;
  hasRequiredIsFunction = 1;
  var isKind2 = requireIsKind();
  function isFunction2(val) {
    return isKind2(val, "Function");
  }
  isFunction_1 = isFunction2;
  return isFunction_1;
}
var toLookup_1;
var hasRequiredToLookup;
function requireToLookup() {
  if (hasRequiredToLookup) return toLookup_1;
  hasRequiredToLookup = 1;
  var isFunction2 = requireIsFunction();
  function toLookup2(arr, key) {
    var result2 = {};
    if (arr == null) {
      return result2;
    }
    var i = -1, len = arr.length, value;
    if (isFunction2(key)) {
      while (++i < len) {
        value = arr[i];
        result2[key(value)] = value;
      }
    } else {
      while (++i < len) {
        value = arr[i];
        result2[value[key]] = value;
      }
    }
    return result2;
  }
  toLookup_1 = toLookup2;
  return toLookup_1;
}
var toLookupExports = requireToLookup();
const toLookup = /* @__PURE__ */ getDefaultExportFromCjs(toLookupExports);
var union_1;
var hasRequiredUnion;
function requireUnion() {
  if (hasRequiredUnion) return union_1;
  hasRequiredUnion = 1;
  var unique2 = requireUnique();
  var append2 = requireAppend();
  function union2(arrs) {
    var results = [];
    var i = -1, len = arguments.length;
    while (++i < len) {
      append2(results, arguments[i]);
    }
    return unique2(results);
  }
  union_1 = union2;
  return union_1;
}
var unionExports = requireUnion();
const union = /* @__PURE__ */ getDefaultExportFromCjs(unionExports);
var uniqueExports = requireUnique();
const unique = /* @__PURE__ */ getDefaultExportFromCjs(uniqueExports);
var xor_1;
var hasRequiredXor;
function requireXor() {
  if (hasRequiredXor) return xor_1;
  hasRequiredXor = 1;
  var unique2 = requireUnique();
  var filter2 = requireFilter$2();
  var contains2 = requireContains$4();
  function xor2(arr1, arr2) {
    arr1 = unique2(arr1);
    arr2 = unique2(arr2);
    var a1 = filter2(arr1, function(item) {
      return !contains2(arr2, item);
    }), a2 = filter2(arr2, function(item) {
      return !contains2(arr1, item);
    });
    return a1.concat(a2);
  }
  xor_1 = xor2;
  return xor_1;
}
var xorExports = requireXor();
const xor = /* @__PURE__ */ getDefaultExportFromCjs(xorExports);
var zip_1;
var hasRequiredZip;
function requireZip() {
  if (hasRequiredZip) return zip_1;
  hasRequiredZip = 1;
  var max2 = requireMax$2();
  var map2 = requireMap$3();
  function getLength(arr) {
    return arr == null ? 0 : arr.length;
  }
  function zip2(arr) {
    var len = arr ? max2(map2(arguments, getLength)) : 0, results = [], i = -1;
    while (++i < len) {
      results.push(map2(arguments, function(item) {
        return item == null ? void 0 : item[i];
      }));
    }
    return results;
  }
  zip_1 = zip2;
  return zip_1;
}
var zipExports = requireZip();
const zip = /* @__PURE__ */ getDefaultExportFromCjs(zipExports);
const BlobUtils = {
  toBase64: (blob) => {
    return new Promise((resolve, reject2) => {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          resolve(reader.result.substr(reader.result.indexOf(",") + 1));
        };
      } catch (err) {
        reject2(err);
      }
    });
  }
};
var make_;
var hasRequiredMake_;
function requireMake_() {
  if (hasRequiredMake_) return make_;
  hasRequiredMake_ = 1;
  var slice2 = requireSlice();
  function makeCollectionMethod(arrMethod, objMethod, defaultReturn) {
    return function() {
      var args = slice2(arguments);
      if (args[0] == null) {
        return defaultReturn;
      }
      return typeof args[0].length === "number" ? arrMethod.apply(null, args) : objMethod.apply(null, args);
    };
  }
  make_ = makeCollectionMethod;
  return make_;
}
var some_1;
var hasRequiredSome$1;
function requireSome$1() {
  if (hasRequiredSome$1) return some_1;
  hasRequiredSome$1 = 1;
  var forOwn2 = requireForOwn();
  var makeIterator = requireMakeIterator_();
  function some2(obj, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var result2 = false;
    forOwn2(obj, function(val, key) {
      if (callback(val, key, obj)) {
        result2 = true;
        return false;
      }
    });
    return result2;
  }
  some_1 = some2;
  return some_1;
}
var contains_1$2;
var hasRequiredContains$3;
function requireContains$3() {
  if (hasRequiredContains$3) return contains_1$2;
  hasRequiredContains$3 = 1;
  var some2 = requireSome$1();
  function contains2(obj, needle) {
    return some2(obj, function(val) {
      return val === needle;
    });
  }
  contains_1$2 = contains2;
  return contains_1$2;
}
var contains$4;
var hasRequiredContains$2;
function requireContains$2() {
  if (hasRequiredContains$2) return contains$4;
  hasRequiredContains$2 = 1;
  var make = requireMake_();
  var arrContains = requireContains$4();
  var objContains = requireContains$3();
  contains$4 = make(arrContains, objContains);
  return contains$4;
}
var containsExports$3 = requireContains$2();
const contains$3 = /* @__PURE__ */ getDefaultExportFromCjs(containsExports$3);
var every_1;
var hasRequiredEvery$1;
function requireEvery$1() {
  if (hasRequiredEvery$1) return every_1;
  hasRequiredEvery$1 = 1;
  var forOwn2 = requireForOwn();
  var makeIterator = requireMakeIterator_();
  function every2(obj, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var result2 = true;
    forOwn2(obj, function(val, key) {
      if (!callback(val, key, obj)) {
        result2 = false;
        return false;
      }
    });
    return result2;
  }
  every_1 = every2;
  return every_1;
}
var every$2;
var hasRequiredEvery;
function requireEvery() {
  if (hasRequiredEvery) return every$2;
  hasRequiredEvery = 1;
  var make = requireMake_();
  var arrEvery = requireEvery$2();
  var objEvery = requireEvery$1();
  every$2 = make(arrEvery, objEvery);
  return every$2;
}
var everyExports$1 = requireEvery();
const every$1 = /* @__PURE__ */ getDefaultExportFromCjs(everyExports$1);
var forEach$1;
var hasRequiredForEach;
function requireForEach() {
  if (hasRequiredForEach) return forEach$1;
  hasRequiredForEach = 1;
  var make = requireMake_();
  var arrForEach = requireForEach$1();
  var objForEach = requireForOwn();
  forEach$1 = make(arrForEach, objForEach);
  return forEach$1;
}
var filter_1;
var hasRequiredFilter$1;
function requireFilter$1() {
  if (hasRequiredFilter$1) return filter_1;
  hasRequiredFilter$1 = 1;
  var forEach2 = requireForEach();
  var makeIterator = requireMakeIterator_();
  function filter2(list, iterator, thisObj) {
    iterator = makeIterator(iterator, thisObj);
    var results = [];
    if (!list) {
      return results;
    }
    forEach2(list, function(value, index, list2) {
      if (iterator(value, index, list2)) {
        results[results.length] = value;
      }
    });
    return results;
  }
  filter_1 = filter2;
  return filter_1;
}
var filterExports$1 = requireFilter$1();
const filter$2 = /* @__PURE__ */ getDefaultExportFromCjs(filterExports$1);
var find_1;
var hasRequiredFind$1;
function requireFind$1() {
  if (hasRequiredFind$1) return find_1;
  hasRequiredFind$1 = 1;
  var some2 = requireSome$1();
  var makeIterator = requireMakeIterator_();
  function find2(obj, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var result2;
    some2(obj, function(value, key, obj2) {
      if (callback(value, key, obj2)) {
        result2 = value;
        return true;
      }
    });
    return result2;
  }
  find_1 = find2;
  return find_1;
}
var find$2;
var hasRequiredFind;
function requireFind() {
  if (hasRequiredFind) return find$2;
  hasRequiredFind = 1;
  var make = requireMake_();
  var arrFind = requireFind$2();
  var objFind = requireFind$1();
  find$2 = make(arrFind, objFind);
  return find$2;
}
var findExports$1 = requireFind();
const find$1 = /* @__PURE__ */ getDefaultExportFromCjs(findExports$1);
var forEachExports = requireForEach();
const forEach = /* @__PURE__ */ getDefaultExportFromCjs(forEachExports);
var isObject_1;
var hasRequiredIsObject;
function requireIsObject() {
  if (hasRequiredIsObject) return isObject_1;
  hasRequiredIsObject = 1;
  var isKind2 = requireIsKind();
  function isObject2(val) {
    return isKind2(val, "Object");
  }
  isObject_1 = isObject2;
  return isObject_1;
}
var values_1;
var hasRequiredValues;
function requireValues() {
  if (hasRequiredValues) return values_1;
  hasRequiredValues = 1;
  var forOwn2 = requireForOwn();
  function values2(obj) {
    var vals = [];
    forOwn2(obj, function(val, key) {
      vals.push(val);
    });
    return vals;
  }
  values_1 = values2;
  return values_1;
}
var map_1$1;
var hasRequiredMap$2;
function requireMap$2() {
  if (hasRequiredMap$2) return map_1$1;
  hasRequiredMap$2 = 1;
  var isObject2 = requireIsObject();
  var values2 = requireValues();
  var arrMap = requireMap$3();
  var makeIterator = requireMakeIterator_();
  function map2(list, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    if (isObject2(list) && list.length == null) {
      list = values2(list);
    }
    return arrMap(list, function(val, key, list2) {
      return callback(val, key, list2);
    });
  }
  map_1$1 = map2;
  return map_1$1;
}
var mapExports$2 = requireMap$2();
const map$3 = /* @__PURE__ */ getDefaultExportFromCjs(mapExports$2);
var max_1;
var hasRequiredMax$1;
function requireMax$1() {
  if (hasRequiredMax$1) return max_1;
  hasRequiredMax$1 = 1;
  var arrMax = requireMax$2();
  var values2 = requireValues();
  function max2(obj, compareFn) {
    return arrMax(values2(obj), compareFn);
  }
  max_1 = max2;
  return max_1;
}
var max$2;
var hasRequiredMax;
function requireMax() {
  if (hasRequiredMax) return max$2;
  hasRequiredMax = 1;
  var make = requireMake_();
  var arrMax = requireMax$2();
  var objMax = requireMax$1();
  max$2 = make(arrMax, objMax);
  return max$2;
}
var maxExports$1 = requireMax();
const max$1 = /* @__PURE__ */ getDefaultExportFromCjs(maxExports$1);
var min_1;
var hasRequiredMin$1;
function requireMin$1() {
  if (hasRequiredMin$1) return min_1;
  hasRequiredMin$1 = 1;
  var arrMin = requireMin$2();
  var values2 = requireValues();
  function min2(obj, iterator) {
    return arrMin(values2(obj), iterator);
  }
  min_1 = min2;
  return min_1;
}
var min$2;
var hasRequiredMin;
function requireMin() {
  if (hasRequiredMin) return min$2;
  hasRequiredMin = 1;
  var make = requireMake_();
  var arrMin = requireMin$2();
  var objMin = requireMin$1();
  min$2 = make(arrMin, objMin);
  return min$2;
}
var minExports$1 = requireMin();
const min$1 = /* @__PURE__ */ getDefaultExportFromCjs(minExports$1);
var pluck_1$1;
var hasRequiredPluck$1;
function requirePluck$1() {
  if (hasRequiredPluck$1) return pluck_1$1;
  hasRequiredPluck$1 = 1;
  var map2 = requireMap$2();
  function pluck2(list, key) {
    return map2(list, function(value) {
      return value[key];
    });
  }
  pluck_1$1 = pluck2;
  return pluck_1$1;
}
var pluckExports$1 = requirePluck$1();
const pluck$1 = /* @__PURE__ */ getDefaultExportFromCjs(pluckExports$1);
var size_1$1;
var hasRequiredSize$1;
function requireSize$1() {
  if (hasRequiredSize$1) return size_1$1;
  hasRequiredSize$1 = 1;
  var forOwn2 = requireForOwn();
  function size2(obj) {
    var count = 0;
    forOwn2(obj, function() {
      count++;
    });
    return count;
  }
  size_1$1 = size2;
  return size_1$1;
}
var reduce_1;
var hasRequiredReduce$1;
function requireReduce$1() {
  if (hasRequiredReduce$1) return reduce_1;
  hasRequiredReduce$1 = 1;
  var forOwn2 = requireForOwn();
  var size2 = requireSize$1();
  function reduce2(obj, callback, memo, thisObj) {
    var initial = arguments.length > 2;
    if (!size2(obj) && !initial) {
      throw new Error("reduce of empty object with no initial value");
    }
    forOwn2(obj, function(value, key, list) {
      if (!initial) {
        memo = value;
        initial = true;
      } else {
        memo = callback.call(thisObj, memo, value, key, list);
      }
    });
    return memo;
  }
  reduce_1 = reduce2;
  return reduce_1;
}
var reduce$2;
var hasRequiredReduce;
function requireReduce() {
  if (hasRequiredReduce) return reduce$2;
  hasRequiredReduce = 1;
  var make = requireMake_();
  var arrReduce = requireReduce$2();
  var objReduce = requireReduce$1();
  reduce$2 = make(arrReduce, objReduce);
  return reduce$2;
}
var reduceExports$1 = requireReduce();
const reduce$1 = /* @__PURE__ */ getDefaultExportFromCjs(reduceExports$1);
var reject_1$1;
var hasRequiredReject$1;
function requireReject$1() {
  if (hasRequiredReject$1) return reject_1$1;
  hasRequiredReject$1 = 1;
  var filter2 = requireFilter$1();
  var makeIterator = requireMakeIterator_();
  function reject2(list, iterator, thisObj) {
    iterator = makeIterator(iterator, thisObj);
    return filter2(list, function(value, index, list2) {
      return !iterator(value, index, list2);
    }, thisObj);
  }
  reject_1$1 = reject2;
  return reject_1$1;
}
var rejectExports$1 = requireReject$1();
const reject$1 = /* @__PURE__ */ getDefaultExportFromCjs(rejectExports$1);
var size_1;
var hasRequiredSize;
function requireSize() {
  if (hasRequiredSize) return size_1;
  hasRequiredSize = 1;
  var isArray2 = requireIsArray();
  var objSize = requireSize$1();
  function size2(list) {
    if (!list) {
      return 0;
    }
    if (isArray2(list)) {
      return list.length;
    }
    return objSize(list);
  }
  size_1 = size2;
  return size_1;
}
var sizeExports$1 = requireSize();
const size$1 = /* @__PURE__ */ getDefaultExportFromCjs(sizeExports$1);
var some$2;
var hasRequiredSome;
function requireSome() {
  if (hasRequiredSome) return some$2;
  hasRequiredSome = 1;
  var make = requireMake_();
  var arrSome = requireSome$2();
  var objSome = requireSome$1();
  some$2 = make(arrSome, objSome);
  return some$2;
}
var someExports$1 = requireSome();
const some$1 = /* @__PURE__ */ getDefaultExportFromCjs(someExports$1);
var isDate_1;
var hasRequiredIsDate;
function requireIsDate() {
  if (hasRequiredIsDate) return isDate_1;
  hasRequiredIsDate = 1;
  var isKind2 = requireIsKind();
  function isDate2(val) {
    return isKind2(val, "Date");
  }
  isDate_1 = isDate2;
  return isDate_1;
}
var dayOfTheYear_1;
var hasRequiredDayOfTheYear;
function requireDayOfTheYear() {
  if (hasRequiredDayOfTheYear) return dayOfTheYear_1;
  hasRequiredDayOfTheYear = 1;
  requireIsDate();
  function dayOfTheYear2(date) {
    return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 1)) / 864e5 + 1;
  }
  dayOfTheYear_1 = dayOfTheYear2;
  return dayOfTheYear_1;
}
var dayOfTheYearExports = requireDayOfTheYear();
const dayOfTheYear = /* @__PURE__ */ getDefaultExportFromCjs(dayOfTheYearExports);
var isLeapYear_1;
var hasRequiredIsLeapYear;
function requireIsLeapYear() {
  if (hasRequiredIsLeapYear) return isLeapYear_1;
  hasRequiredIsLeapYear = 1;
  var isDate2 = requireIsDate();
  function isLeapYear2(fullYear) {
    if (isDate2(fullYear)) {
      fullYear = fullYear.getFullYear();
    }
    return fullYear % 400 === 0 || fullYear % 100 !== 0 && fullYear % 4 === 0;
  }
  isLeapYear_1 = isLeapYear2;
  return isLeapYear_1;
}
var totalDaysInMonth_1;
var hasRequiredTotalDaysInMonth;
function requireTotalDaysInMonth() {
  if (hasRequiredTotalDaysInMonth) return totalDaysInMonth_1;
  hasRequiredTotalDaysInMonth = 1;
  var isDate2 = requireIsDate();
  var isLeapYear2 = requireIsLeapYear();
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function totalDaysInMonth2(fullYear, monthIndex) {
    if (isDate2(fullYear)) {
      monthIndex = fullYear.getMonth();
    }
    if (monthIndex === 1 && isLeapYear2(fullYear)) {
      return 29;
    } else {
      return DAYS_IN_MONTH[monthIndex];
    }
  }
  totalDaysInMonth_1 = totalDaysInMonth2;
  return totalDaysInMonth_1;
}
var totalDaysInYear_1;
var hasRequiredTotalDaysInYear;
function requireTotalDaysInYear() {
  if (hasRequiredTotalDaysInYear) return totalDaysInYear_1;
  hasRequiredTotalDaysInYear = 1;
  var isLeapYear2 = requireIsLeapYear();
  function totalDaysInYear2(fullYear) {
    return isLeapYear2(fullYear) ? 366 : 365;
  }
  totalDaysInYear_1 = totalDaysInYear2;
  return totalDaysInYear_1;
}
var convert_1;
var hasRequiredConvert;
function requireConvert() {
  if (hasRequiredConvert) return convert_1;
  hasRequiredConvert = 1;
  function convert2(val, sourceUnitName, destinationUnitName) {
    destinationUnitName = destinationUnitName || "ms";
    return val * getUnit(sourceUnitName) / getUnit(destinationUnitName);
  }
  function getUnit(unitName) {
    switch (unitName) {
      case "ms":
      case "millisecond":
        return 1;
      case "s":
      case "second":
        return 1e3;
      case "m":
      case "minute":
        return 6e4;
      case "h":
      case "hour":
        return 36e5;
      case "d":
      case "day":
        return 864e5;
      case "w":
      case "week":
        return 6048e5;
      default:
        throw new Error('"' + unitName + '" is not a valid unit');
    }
  }
  convert_1 = convert2;
  return convert_1;
}
var diff_1;
var hasRequiredDiff;
function requireDiff() {
  if (hasRequiredDiff) return diff_1;
  hasRequiredDiff = 1;
  var totalDaysInMonth2 = requireTotalDaysInMonth();
  var totalDaysInYear2 = requireTotalDaysInYear();
  var convert2 = requireConvert();
  function diff2(start, end, unitName) {
    if (start > end) {
      var swap = start;
      start = end;
      end = swap;
    }
    var output;
    if (unitName === "month") {
      output = getMonthsDiff(start, end);
    } else if (unitName === "year") {
      output = getYearsDiff(start, end);
    } else if (unitName != null) {
      if (unitName === "day") {
        start = toUtc(start);
        end = toUtc(end);
      }
      output = convert2(end - start, "ms", unitName);
    } else {
      output = end - start;
    }
    return output;
  }
  function toUtc(d) {
    return Date.UTC(
      d.getUTCFullYear(),
      d.getUTCMonth(),
      d.getUTCDate(),
      d.getHours(),
      d.getMinutes(),
      d.getSeconds(),
      d.getMilliseconds()
    );
  }
  function getMonthsDiff(start, end) {
    return getElapsedMonths(start, end) + getElapsedYears(start, end) * 12 + getFractionalMonth(start, end);
  }
  function getYearsDiff(start, end) {
    var elapsedYears = getElapsedYears(start, end);
    return elapsedYears + getFractionalYear(start, end, elapsedYears);
  }
  function getElapsedMonths(start, end) {
    var monthDiff = end.getMonth() - start.getMonth();
    if (monthDiff < 0) {
      monthDiff += 12;
    }
    if (start.getDate() > end.getDate()) {
      monthDiff -= 1;
    }
    return monthDiff;
  }
  function getElapsedYears(start, end) {
    var yearDiff = end.getFullYear() - start.getFullYear();
    if (start.getMonth() > end.getMonth()) {
      yearDiff -= 1;
    }
    return yearDiff;
  }
  function getFractionalMonth(start, end) {
    var fractionalDiff = 0;
    var startDay = start.getDate();
    var endDay = end.getDate();
    if (startDay !== endDay) {
      var startTotalDays = totalDaysInMonth2(start);
      var endTotalDays = totalDaysInMonth2(end);
      var totalDays;
      var daysElapsed;
      if (startDay > endDay) {
        var baseDay = startTotalDays - startDay;
        daysElapsed = endDay + baseDay;
        totalDays = startDay > endTotalDays ? endTotalDays + baseDay + 1 : startDay + baseDay;
      } else {
        daysElapsed = endDay - startDay;
        totalDays = endTotalDays;
      }
      fractionalDiff = daysElapsed / totalDays;
    }
    return fractionalDiff;
  }
  function getFractionalYear(start, end, elapsedYears) {
    var base = elapsedYears ? new Date(end.getFullYear(), start.getMonth(), start.getDate()) : start;
    var elapsedDays = diff2(base, end, "day");
    return elapsedDays / totalDaysInYear2(end);
  }
  diff_1 = diff2;
  return diff_1;
}
var diffExports = requireDiff();
const diff$1 = /* @__PURE__ */ getDefaultExportFromCjs(diffExports);
var isLeapYearExports = requireIsLeapYear();
const isLeapYear$1 = /* @__PURE__ */ getDefaultExportFromCjs(isLeapYearExports);
var isPlainObject_1;
var hasRequiredIsPlainObject;
function requireIsPlainObject() {
  if (hasRequiredIsPlainObject) return isPlainObject_1;
  hasRequiredIsPlainObject = 1;
  function isPlainObject2(value) {
    return !!value && typeof value === "object" && value.constructor === Object;
  }
  isPlainObject_1 = isPlainObject2;
  return isPlainObject_1;
}
var mixIn_1;
var hasRequiredMixIn;
function requireMixIn() {
  if (hasRequiredMixIn) return mixIn_1;
  hasRequiredMixIn = 1;
  var forOwn2 = requireForOwn();
  function mixIn2(target, objects) {
    var i = 0, n2 = arguments.length, obj;
    while (++i < n2) {
      obj = arguments[i];
      if (obj != null) {
        forOwn2(obj, copyProp, target);
      }
    }
    return target;
  }
  function copyProp(val, key) {
    this[key] = val;
  }
  mixIn_1 = mixIn2;
  return mixIn_1;
}
var clone_1;
var hasRequiredClone;
function requireClone() {
  if (hasRequiredClone) return clone_1;
  hasRequiredClone = 1;
  var kindOf2 = requireKindOf();
  var isPlainObject2 = requireIsPlainObject();
  var mixIn2 = requireMixIn();
  function clone2(val) {
    switch (kindOf2(val)) {
      case "Object":
        return cloneObject(val);
      case "Array":
        return cloneArray(val);
      case "RegExp":
        return cloneRegExp(val);
      case "Date":
        return cloneDate(val);
      default:
        return val;
    }
  }
  function cloneObject(source) {
    if (isPlainObject2(source)) {
      return mixIn2({}, source);
    } else {
      return source;
    }
  }
  function cloneRegExp(r) {
    var flags = "";
    flags += r.multiline ? "m" : "";
    flags += r.global ? "g" : "";
    flags += r.ignoreCase ? "i" : "";
    return new RegExp(r.source, flags);
  }
  function cloneDate(date) {
    return /* @__PURE__ */ new Date(+date);
  }
  function cloneArray(arr) {
    return arr.slice();
  }
  clone_1 = clone2;
  return clone_1;
}
var startOf_1;
var hasRequiredStartOf;
function requireStartOf() {
  if (hasRequiredStartOf) return startOf_1;
  hasRequiredStartOf = 1;
  var clone2 = requireClone();
  function startOf2(date, period) {
    date = clone2(date);
    switch (period) {
      case "year":
        date.setMonth(0);
      /* falls through */
      case "month":
        date.setDate(1);
      /* falls through */
      case "week":
      case "day":
        date.setHours(0);
      /* falls through */
      case "hour":
        date.setMinutes(0);
      /* falls through */
      case "minute":
        date.setSeconds(0);
      /* falls through */
      case "second":
        date.setMilliseconds(0);
        break;
      default:
        throw new Error('"' + period + '" is not a valid period');
    }
    if (period === "week") {
      var weekDay = date.getDay();
      var baseDate = date.getDate();
      if (weekDay) {
        if (weekDay >= baseDate) {
          date.setDate(0);
        }
        date.setDate(date.getDate() - date.getDay());
      }
    }
    return date;
  }
  startOf_1 = startOf2;
  return startOf_1;
}
var isSame_1;
var hasRequiredIsSame;
function requireIsSame() {
  if (hasRequiredIsSame) return isSame_1;
  hasRequiredIsSame = 1;
  var startOf2 = requireStartOf();
  function isSame2(date1, date2, period) {
    if (period) {
      date1 = startOf2(date1, period);
      date2 = startOf2(date2, period);
    }
    return Number(date1) === Number(date2);
  }
  isSame_1 = isSame2;
  return isSame_1;
}
var isSameExports = requireIsSame();
const isSame = /* @__PURE__ */ getDefaultExportFromCjs(isSameExports);
var parseIso$1;
var hasRequiredParseIso;
function requireParseIso() {
  if (hasRequiredParseIso) return parseIso$1;
  hasRequiredParseIso = 1;
  var some2 = requireSome$2();
  var datePatterns = [
    /^([0-9]{4})$/,
    // YYYY
    /^([0-9]{4})-([0-9]{2})$/,
    // YYYY-MM (YYYYMM not allowed)
    /^([0-9]{4})-?([0-9]{2})-?([0-9]{2})$/
    // YYYY-MM-DD or YYYYMMDD
  ];
  var ORD_DATE = /^([0-9]{4})-?([0-9]{3})$/;
  var timePatterns = [
    /^([0-9]{2}(?:\.[0-9]*)?)$/,
    // HH.hh
    /^([0-9]{2}):?([0-9]{2}(?:\.[0-9]*)?)$/,
    // HH:MM.mm
    /^([0-9]{2}):?([0-9]{2}):?([0-9]{2}(\.[0-9]*)?)$/
    // HH:MM:SS.ss
  ];
  var DATE_TIME = /^(.+)T(.+)$/;
  var TIME_ZONE = /^(.+)([+\-])([0-9]{2}):?([0-9]{2})$/;
  function matchAll(str, patterns) {
    var match2;
    var found = some2(patterns, function(pattern) {
      return !!(match2 = pattern.exec(str));
    });
    return found ? match2 : null;
  }
  function getDate(year, month, day) {
    var date = new Date(Date.UTC(year, month, day));
    date.setUTCFullYear(year);
    var valid = date.getUTCFullYear() === year && date.getUTCMonth() === month && date.getUTCDate() === day;
    return valid ? +date : NaN;
  }
  function parseOrdinalDate(str) {
    var match2 = ORD_DATE.exec(str);
    if (match2) {
      var year = +match2[1], day = +match2[2], date = new Date(Date.UTC(year, 0, day));
      if (date.getUTCFullYear() === year) {
        return +date;
      }
    }
    return NaN;
  }
  function parseDate(str) {
    var match2, year, month, day;
    match2 = matchAll(str, datePatterns);
    if (match2 === null) {
      return parseOrdinalDate(str);
    }
    year = match2[1] === void 0 ? 0 : +match2[1];
    month = match2[2] === void 0 ? 0 : +match2[2] - 1;
    day = match2[3] === void 0 ? 1 : +match2[3];
    return getDate(year, month, day);
  }
  function getTime(hr, min2, sec) {
    var valid = hr < 24 && hr >= 0 && min2 < 60 && min2 >= 0 && sec < 60 && min2 >= 0 || hr === 24 && min2 === 0 && sec === 0;
    if (!valid) {
      return NaN;
    }
    return ((hr * 60 + min2) * 60 + sec) * 1e3;
  }
  function parseOffset(str) {
    var match2;
    if (str.charAt(str.length - 1) === "Z") {
      str = str.substring(0, str.length - 1);
    } else {
      match2 = TIME_ZONE.exec(str);
      if (match2) {
        var hours = +match2[3], minutes = match2[4] === void 0 ? 0 : +match2[4], offset2 = getTime(hours, minutes, 0);
        if (match2[2] === "-") {
          offset2 *= -1;
        }
        return { offset: offset2, time: match2[1] };
      }
    }
    return { offset: 0, time: str };
  }
  function parseTime(str) {
    var match2;
    var offset2 = parseOffset(str);
    str = offset2.time;
    offset2 = offset2.offset;
    if (isNaN(offset2)) {
      return NaN;
    }
    match2 = matchAll(str, timePatterns);
    if (match2 === null) {
      return NaN;
    }
    var hours = match2[1] === void 0 ? 0 : +match2[1], minutes = match2[2] === void 0 ? 0 : +match2[2], seconds = match2[3] === void 0 ? 0 : +match2[3];
    return getTime(hours, minutes, seconds) - offset2;
  }
  function parseISO8601(str) {
    var match2 = DATE_TIME.exec(str);
    if (!match2) {
      return parseDate(str);
    }
    return parseDate(match2[1]) + parseTime(match2[2]);
  }
  parseIso$1 = parseISO8601;
  return parseIso$1;
}
var parseIsoExports = requireParseIso();
const parseIso = /* @__PURE__ */ getDefaultExportFromCjs(parseIsoExports);
var quarter_1;
var hasRequiredQuarter;
function requireQuarter() {
  if (hasRequiredQuarter) return quarter_1;
  hasRequiredQuarter = 1;
  function quarter2(date) {
    var month = date.getMonth();
    if (month < 3) return 1;
    if (month < 6) return 2;
    if (month < 9) return 3;
    return 4;
  }
  quarter_1 = quarter2;
  return quarter_1;
}
var quarterExports = requireQuarter();
const quarter = /* @__PURE__ */ getDefaultExportFromCjs(quarterExports);
var startOfExports = requireStartOf();
const startOf = /* @__PURE__ */ getDefaultExportFromCjs(startOfExports);
var toString_1;
var hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return toString_1;
  hasRequiredToString = 1;
  function toString2(val) {
    return val == null ? "" : val.toString();
  }
  toString_1 = toString2;
  return toString_1;
}
var toInt_1;
var hasRequiredToInt;
function requireToInt() {
  if (hasRequiredToInt) return toInt_1;
  hasRequiredToInt = 1;
  function toInt2(val) {
    return ~~val;
  }
  toInt_1 = toInt2;
  return toInt_1;
}
var repeat_1;
var hasRequiredRepeat;
function requireRepeat() {
  if (hasRequiredRepeat) return repeat_1;
  hasRequiredRepeat = 1;
  var toString2 = requireToString();
  var toInt2 = requireToInt();
  function repeat2(str, n2) {
    var result2 = "";
    str = toString2(str);
    n2 = toInt2(n2);
    if (n2 < 1) {
      return "";
    }
    while (n2 > 0) {
      if (n2 % 2) {
        result2 += str;
      }
      n2 = Math.floor(n2 / 2);
      str += str;
    }
    return result2;
  }
  repeat_1 = repeat2;
  return repeat_1;
}
var lpad_1;
var hasRequiredLpad;
function requireLpad() {
  if (hasRequiredLpad) return lpad_1;
  hasRequiredLpad = 1;
  var toString2 = requireToString();
  var repeat2 = requireRepeat();
  function lpad2(str, minLen, ch) {
    str = toString2(str);
    ch = ch || " ";
    return str.length < minLen ? repeat2(ch, minLen - str.length) + str : str;
  }
  lpad_1 = lpad2;
  return lpad_1;
}
var toNumber_1;
var hasRequiredToNumber;
function requireToNumber() {
  if (hasRequiredToNumber) return toNumber_1;
  hasRequiredToNumber = 1;
  var isArray2 = requireIsArray();
  function toNumber2(val) {
    if (typeof val === "number") return val;
    if (!val) return 0;
    if (typeof val === "string") return parseFloat(val);
    if (isArray2(val)) return NaN;
    return Number(val);
  }
  toNumber_1 = toNumber2;
  return toNumber_1;
}
var pad_1;
var hasRequiredPad;
function requirePad() {
  if (hasRequiredPad) return pad_1;
  hasRequiredPad = 1;
  var lpad2 = requireLpad();
  var toNumber2 = requireToNumber();
  function pad2(n2, minLength, char) {
    n2 = toNumber2(n2);
    return lpad2("" + n2, minLength, char || "0");
  }
  pad_1 = pad2;
  return pad_1;
}
var enUS;
var hasRequiredEnUS;
function requireEnUS() {
  if (hasRequiredEnUS) return enUS;
  hasRequiredEnUS = 1;
  enUS = {
    "am": "AM",
    "pm": "PM",
    "x": "%m/%d/%y",
    "X": "%H:%M:%S",
    "c": "%a %d %b %Y %I:%M:%S %p %Z",
    "months": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "months_abbr": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "days": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "days_abbr": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ]
  };
  return enUS;
}
var i18n_;
var hasRequiredI18n_;
function requireI18n_() {
  if (hasRequiredI18n_) return i18n_;
  hasRequiredI18n_ = 1;
  var mixIn2 = requireMixIn();
  var enUS2 = requireEnUS();
  var activeLocale = mixIn2({}, enUS2, {
    // we expose a "set" method to allow overriding the global locale
    set: function(localeData) {
      mixIn2(activeLocale, localeData);
    }
  });
  i18n_ = activeLocale;
  return i18n_;
}
var timezoneOffset_1;
var hasRequiredTimezoneOffset;
function requireTimezoneOffset() {
  if (hasRequiredTimezoneOffset) return timezoneOffset_1;
  hasRequiredTimezoneOffset = 1;
  var pad2 = requirePad();
  function timezoneOffset2(date) {
    var offset2 = date.getTimezoneOffset();
    var abs = Math.abs(offset2);
    var h = pad2(Math.floor(abs / 60), 2);
    var m = pad2(abs % 60, 2);
    return (offset2 > 0 ? "-" : "+") + h + m;
  }
  timezoneOffset_1 = timezoneOffset2;
  return timezoneOffset_1;
}
var timezoneAbbr_1;
var hasRequiredTimezoneAbbr;
function requireTimezoneAbbr() {
  if (hasRequiredTimezoneAbbr) return timezoneAbbr_1;
  hasRequiredTimezoneAbbr = 1;
  var timezoneOffset2 = requireTimezoneOffset();
  function timezoneAbbr2(date) {
    var tz = /\(([A-Z]{3,4})\)/.exec(date.toString());
    return tz ? tz[1] : timezoneOffset2(date);
  }
  timezoneAbbr_1 = timezoneAbbr2;
  return timezoneAbbr_1;
}
var weekOfTheYear_1;
var hasRequiredWeekOfTheYear;
function requireWeekOfTheYear() {
  if (hasRequiredWeekOfTheYear) return weekOfTheYear_1;
  hasRequiredWeekOfTheYear = 1;
  var dayOfTheYear2 = requireDayOfTheYear();
  function weekOfTheYear2(date, firstDayOfWeek) {
    firstDayOfWeek = firstDayOfWeek == null ? 0 : firstDayOfWeek;
    var doy = dayOfTheYear2(date);
    var dow = (7 + date.getDay() - firstDayOfWeek) % 7;
    var relativeWeekDay = 6 - firstDayOfWeek - dow;
    return Math.floor((doy + relativeWeekDay) / 7);
  }
  weekOfTheYear_1 = weekOfTheYear2;
  return weekOfTheYear_1;
}
var strftime_1;
var hasRequiredStrftime;
function requireStrftime() {
  if (hasRequiredStrftime) return strftime_1;
  hasRequiredStrftime = 1;
  var pad2 = requirePad();
  var lpad2 = requireLpad();
  var i18n = requireI18n_();
  var dayOfTheYear2 = requireDayOfTheYear();
  var timezoneOffset2 = requireTimezoneOffset();
  var timezoneAbbr2 = requireTimezoneAbbr();
  var weekOfTheYear2 = requireWeekOfTheYear();
  var _combinations = {
    "D": "%m/%d/%y",
    "F": "%Y-%m-%d",
    "r": "%I:%M:%S %p",
    "R": "%H:%M",
    "T": "%H:%M:%S",
    "x": "locale",
    "X": "locale",
    "c": "locale"
  };
  function strftime2(date, format, localeData) {
    localeData = localeData || i18n;
    var reToken = /%([a-z%])/gi;
    function makeIterator(fn) {
      return function(match2, token) {
        return fn(date, token, localeData);
      };
    }
    return format.replace(reToken, makeIterator(expandCombinations)).replace(reToken, makeIterator(convertToken));
  }
  function expandCombinations(date, token, l10n) {
    if (token in _combinations) {
      var expanded = _combinations[token];
      return expanded === "locale" ? l10n[token] : expanded;
    } else {
      return "%" + token;
    }
  }
  function convertToken(date, token, l10n) {
    switch (token) {
      case "a":
        return l10n.days_abbr[date.getDay()];
      case "A":
        return l10n.days[date.getDay()];
      case "h":
      case "b":
        return l10n.months_abbr[date.getMonth()];
      case "B":
        return l10n.months[date.getMonth()];
      case "C":
        return pad2(Math.floor(date.getFullYear() / 100), 2);
      case "d":
        return pad2(date.getDate(), 2);
      case "e":
        return pad2(date.getDate(), 2, " ");
      case "H":
        return pad2(date.getHours(), 2);
      case "I":
        return pad2(date.getHours() % 12, 2);
      case "j":
        return pad2(dayOfTheYear2(date), 3);
      case "l":
        return lpad2(date.getHours() % 12, 2);
      case "L":
        return pad2(date.getMilliseconds(), 3);
      case "m":
        return pad2(date.getMonth() + 1, 2);
      case "M":
        return pad2(date.getMinutes(), 2);
      case "n":
        return "\n";
      case "p":
        return date.getHours() >= 12 ? l10n.pm : l10n.am;
      case "P":
        return convertToken(date, "p", l10n).toLowerCase();
      case "s":
        return date.getTime() / 1e3;
      case "S":
        return pad2(date.getSeconds(), 2);
      case "t":
        return "	";
      case "u":
        var day = date.getDay();
        return day === 0 ? 7 : day;
      case "U":
        return pad2(weekOfTheYear2(date), 2);
      case "w":
        return date.getDay();
      case "W":
        return pad2(weekOfTheYear2(date, 1), 2);
      case "y":
        return pad2(date.getFullYear() % 100, 2);
      case "Y":
        return pad2(date.getFullYear(), 4);
      case "z":
        return timezoneOffset2(date);
      case "Z":
        return timezoneAbbr2(date);
      case "%":
        return "%";
      default:
        return "%" + token;
    }
  }
  strftime_1 = strftime2;
  return strftime_1;
}
var strftimeExports = requireStrftime();
const strftime = /* @__PURE__ */ getDefaultExportFromCjs(strftimeExports);
var timezoneAbbrExports = requireTimezoneAbbr();
const timezoneAbbr = /* @__PURE__ */ getDefaultExportFromCjs(timezoneAbbrExports);
var timezoneOffsetExports = requireTimezoneOffset();
const timezoneOffset = /* @__PURE__ */ getDefaultExportFromCjs(timezoneOffsetExports);
var totalDaysInMonthExports = requireTotalDaysInMonth();
const totalDaysInMonth = /* @__PURE__ */ getDefaultExportFromCjs(totalDaysInMonthExports);
var totalDaysInYearExports = requireTotalDaysInYear();
const totalDaysInYear = /* @__PURE__ */ getDefaultExportFromCjs(totalDaysInYearExports);
var weekOfTheYearExports = requireWeekOfTheYear();
const weekOfTheYear = /* @__PURE__ */ getDefaultExportFromCjs(weekOfTheYearExports);
class LuxonError extends Error {
}
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}
class ConflictingSpecificationError extends LuxonError {
}
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}
class InvalidArgumentError extends LuxonError {
}
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}
const n = "numeric", s = "short", l = "long";
const DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
const DATE_MED = {
  year: n,
  month: s,
  day: n
};
const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
const DATE_FULL = {
  year: n,
  month: l,
  day: n
};
const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
const TIME_SIMPLE = {
  hour: n,
  minute: n
};
const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}
let singleton$1 = null;
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
}
const dtfCache = /* @__PURE__ */ new Map();
function makeDTF(zoneName) {
  let dtf = dtfCache.get(zoneName);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zoneName,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
    dtfCache.set(zoneName, dtf);
  }
  return dtf;
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined$2(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
const ianaZoneCache = /* @__PURE__ */ new Map();
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    let zone = ianaZoneCache.get(name);
    if (zone === void 0) {
      ianaZoneCache.set(name, zone = new IANAZone(name));
    }
    return zone;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache.clear();
    dtfCache.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = IANAZone.isValidZone(name);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    if (!this.valid) return NaN;
    const date = new Date(ts);
    if (isNaN(date)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
const intlDTCache = /* @__PURE__ */ new Map();
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache.get(key);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache.set(key, dtf);
  }
  return dtf;
}
const intlNumCache = /* @__PURE__ */ new Map();
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache.get(key);
  if (inf === void 0) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache.set(key, inf);
  }
  return inf;
}
const intlRelCache = /* @__PURE__ */ new Map();
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache.get(key);
  if (inf === void 0) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache.set(key, inf);
  }
  return inf;
}
let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
const intlResolvedOptionsCache = /* @__PURE__ */ new Map();
function getCachedIntResolvedOptions(locString) {
  let opts = intlResolvedOptionsCache.get(locString);
  if (opts === void 0) {
    opts = new Intl.DateTimeFormat(locString).resolvedOptions();
    intlResolvedOptionsCache.set(locString, opts);
  }
  return opts;
}
const weekInfoCache = /* @__PURE__ */ new Map();
function getCachedWeekInfo(locString) {
  let data = weekInfoCache.get(locString);
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    if (!("minimalDays" in data)) {
      data = { ...fallbackWeekSettings, ...data };
    }
    weekInfoCache.set(locString, data);
  }
  return data;
}
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
  }
}
class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor: floor2, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}
class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return {
            ...part,
            value: offsetName
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}
const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class Locale {
  static fromOpts(opts) {
    return Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache.clear();
    intlNumCache.clear();
    intlRelCache.clear();
    intlResolvedOptionsCache.clear();
    weekInfoCache.clear();
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
      format &= !monthSpecialCase;
      const intl = format ? { month: length, day: "numeric" } : { month: length }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        const mapper = !monthSpecialCase ? (dt) => this.extract(dt, intl, "month") : (dt) => this.dtFormatter(dt, intl).format();
        this.monthsCache[formatStr][length] = mapMonths(mapper);
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? { weekday: length, year: "numeric", month: "long", day: "numeric" } : { weekday: length }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays(
          (dt) => this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(
      this,
      void 0,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = { era: length };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(
          (dt) => this.extract(dt, intl, "era")
        );
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let singleton = null;
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset2) {
    return offset2 === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset2);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s2) {
    if (s2) {
      const r = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
}
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
}
function normalizeZone(input, defaultZone2) {
  if (isUndefined$2(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString$1(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber$1(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
const numberingSystems = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
};
const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min2, max2] = numberingSystemsUTF16[key];
          if (code >= min2 && code <= max2) {
            value += code - min2;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
const digitRegexCache = /* @__PURE__ */ new Map();
function resetDigitRegexCache() {
  digitRegexCache.clear();
}
function digitRegex({ numberingSystem }, append2 = "") {
  const ns = numberingSystem || "latn";
  let appendCache = digitRegexCache.get(ns);
  if (appendCache === void 0) {
    appendCache = /* @__PURE__ */ new Map();
    digitRegexCache.set(ns, appendCache);
  }
  let regex = appendCache.get(append2);
  if (regex === void 0) {
    regex = new RegExp(`${numberingSystems[ns]}${append2}`);
    appendCache.set(append2, regex);
  }
  return regex;
}
let now$2 = () => Date.now(), defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now$2;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n2) {
    now$2 = n2;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
}
class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}
const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal2) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal2), day = ordinal2 - table[month0];
  return { month: month0 + 1, day };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal2 = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal2 - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal2 = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal2 < 1) {
    year = weekYear - 1;
    ordinal2 += daysInYear(year);
  } else if (ordinal2 > yearInDays) {
    year = weekYear + 1;
    ordinal2 -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal2);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal2 = computeOrdinal(year, month, day);
  return { year, ordinal: ordinal2, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  const { year, ordinal: ordinal2 } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal2);
  return { year, month, day, ...timeObject(ordinalData) };
}
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined$2(obj.localWeekday) || !isUndefined$2(obj.localWeekNumber) || !isUndefined$2(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined$2(obj.weekday) || !isUndefined$2(obj.weekNumber) || !isUndefined$2(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined$2(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined$2(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined$2(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger$1(obj.weekYear), validWeek = integerBetween(
    obj.weekNumber,
    1,
    weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
  ), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger$1(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger$1(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}
function isUndefined$2(o) {
  return typeof o === "undefined";
}
function isNumber$1(o) {
  return typeof o === "number";
}
function isInteger$1(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString$1(o) {
  return typeof o === "string";
}
function isDate$1(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick$1(obj, keys2) {
  return keys2.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop2) {
  return Object.prototype.hasOwnProperty.call(obj, prop2);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
function integerBetween(thing, bottom, top) {
  return isInteger$1(thing) && thing >= bottom && thing <= top;
}
function floorMod(x, n2) {
  return x - n2 * Math.floor(x / n2);
}
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined$2(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined$2(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  if (isUndefined$2(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
function roundTo(number, digits, rounding = "round") {
  const factor = 10 ** digits;
  switch (rounding) {
    case "expand":
      return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
    case "trunc":
      return Math.trunc(number * factor) / factor;
    case "round":
      return Math.round(number * factor) / factor;
    case "floor":
      return Math.floor(number * factor) / factor;
    case "ceil":
      return Math.ceil(number * factor) / factor;
    default:
      throw new RangeError(`Value rounding ${rounding} is out of range`);
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign2 = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign2}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign2}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign2}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick$1(obj, ["hour", "minute", "second", "millisecond"]);
}
const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems = ["AM", "PM"];
const erasLong = ["Before Christ", "Anno Domini"];
const erasShort = ["BC", "AD"];
const erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0 || bracketed) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull === "" ? "'" : currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p = 0, signDisplay = void 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p);
    }
    const opts = { ...this.opts };
    if (p > 0) {
      opts.padTo = p;
    }
    if (signDisplay) {
      opts.signDisplay = signDisplay;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract) => this.loc.extract(dt, opts, extract), formatOffset2 = (opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, meridiem = () => knownEnglish ? meridiemForDateTime(dt) : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), month = (length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"), weekday = (length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string(
      standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
      "weekday"
    ), maybeMacro = (token) => {
      const formatOpts = Formatter.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, era = (length) => knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"), tokenToString = (token) => {
      switch (token) {
        // ms
        case "S":
          return this.num(dt.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(dt.millisecond, 3);
        // seconds
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        // minutes
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        // hours
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        // offset
        case "Z":
          return formatOffset2({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return formatOffset2({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return formatOffset2({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return dt.zoneName;
        // meridiems
        case "a":
          return meridiem();
        // dates
        case "d":
          return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        // weekdays - format
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        // months - standalone
        case "L":
          return useDateTimeFormatter ? string({ month: "numeric", day: "numeric" }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string({ month: "2-digit", day: "numeric" }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        // months - format
        case "M":
          return useDateTimeFormatter ? string({ month: "numeric" }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string({ month: "2-digit" }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        // years
        case "y":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string({ year: "2-digit" }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 6);
        // eras
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
    const tokenToField = (token) => {
      switch (token[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, tokenToString = (lildur, info) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        const inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
        let signDisplay;
        if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) {
          signDisplay = "never";
        } else if (this.opts.signMode === "all") {
          signDisplay = "always";
        } else {
          signDisplay = "auto";
        }
        return this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
      } else {
        return token;
      }
    }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(
      (found, { literal, val }) => literal ? found : found.concat(val),
      []
    ), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t)), durationInfo = {
      isNegativeDuration: collapsed < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(collapsed.values)[0]
    };
    return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
  }
}
const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(
    ([mergedVals, mergedZone, cursor], ex) => {
      const [val, zone, next] = ex(m, cursor);
      return [{ ...mergedVals, ...val }, zone || mergedZone, next];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse$1(s2, ...patterns) {
  if (s2 == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s2);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse(...keys2) {
  return (match2, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys2.length; i++) {
      ret[keys2[i]] = parseInteger(match2[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}
const offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:[Tt]${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined$2(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [{}, zone, cursor + 1];
}
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
const isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result2 = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result2.second = parseInteger(secondStr);
  if (weekdayStr) {
    result2.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result2;
}
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [
    ,
    weekdayStr,
    dayStr,
    monthStr,
    yearStr,
    hourStr,
    minuteStr,
    secondStr,
    obsOffset,
    milOffset,
    offHourStr,
    offMinuteStr
  ] = match2, result2 = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [result2, new FixedOffsetZone(offset2)];
}
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result2 = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result2, FixedOffsetZone.utcInstance];
}
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result2 = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result2, FixedOffsetZone.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(s2) {
  return parse$1(
    s2,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(s2) {
  return parse$1(preprocessRFC2822(s2), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s2) {
  return parse$1(
    s2,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(s2) {
  return parse$1(s2, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse$1(s2, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(s2) {
  return parse$1(
    s2,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}
const INVALID$2 = "Invalid Duration";
const lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, casualMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
}, daysInYearAccurate = 146097 / 400, daysInMonthAccurate = 146097 / 4800, accurateMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
const reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$1(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...alts.values || {} },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined$2(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined$2(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
class Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`
      );
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber$1(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }
  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2;
    const showZeros = opts.showZeros !== false;
    const l2 = orderedUnits$1.map((unit) => {
      const val = this.values[unit];
      if (isUndefined$2(val) || val === 0 && !showZeros) {
        return null;
      }
      return this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts }).format(l2);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let s2 = "P";
    if (this.years !== 0) s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s2 += this.weeks + "W";
    if (this.days !== 0) s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s2 += "T";
    if (this.hours !== 0) s2 += this.hours + "H";
    if (this.minutes !== 0) s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P") s2 += "T0S";
    return s2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false
    };
    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration), result2 = {};
    for (const k of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result2[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, { values: result2 }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result2 = {};
    for (const k of Object.keys(this.values)) {
      result2[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, { values: result2 }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values2) {
    if (!this.isValid) return this;
    const mixed = { ...this.values, ...normalizeObject(values2, Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber$1(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber$1(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$1(this, { values: built }, true);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.values);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0) return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}
const INVALID$1 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}
class Interval {
  /**
   * @private
   */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s2, e] = (text || "").split("/", 2);
    if (s2 && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e2) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e2) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid ? this.e ? this.e.minus(1) : null : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts?.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s2 } = this, i = 0;
    while (s2 < this.e) {
      const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s2, next));
      s2 = next;
      i += 1;
    }
    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s2 = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
    if (s2 >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s2, e);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s2 = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s2, e);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(
      ([sofar, current], item) => {
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      },
      [[], null]
    );
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      { time: i.s, type: "s" },
      { time: i.e, type: "e" }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
}
function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s2]) => post(parseDigits(s2)) };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s2]) => strings.findIndex((i) => stripInsensitivities(s2) === stripInsensitivities(i)) + startIndex
    };
  }
}
function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}
function simple(regex) {
  return { regex, deser: ([s2]) => s2 };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(token, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s2]) => s2, literal: true }), unitate = (t) => {
    if (token.literal) {
      return literal(t);
    }
    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      // years
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      // months
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      // dates
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      // ordinals
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      // time
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      // meridiem
      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      // weekdays
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal(t);
    }
  };
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}
function match(input, regex, handlers) {
  const matches2 = input.match(regex);
  if (matches2) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches2.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches2, all];
  } else {
    return [matches2, {}];
  }
}
function dateTimeFromMatches(matches2) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined$2(matches2.z)) {
    zone = IANAZone.create(matches2.z);
  }
  if (!isUndefined$2(matches2.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches2.Z);
    }
    specificOffset = matches2.Z;
  }
  if (!isUndefined$2(matches2.q)) {
    matches2.M = (matches2.q - 1) * 3 + 1;
  }
  if (!isUndefined$2(matches2.h)) {
    if (matches2.h < 12 && matches2.a === 1) {
      matches2.h += 12;
    } else if (matches2.h === 12 && matches2.a === 0) {
      matches2.h = 0;
    }
  }
  if (matches2.G === 0 && matches2.y) {
    matches2.y = -matches2.y;
  }
  if (!isUndefined$2(matches2.u)) {
    matches2.S = parseMillis(matches2.u);
  }
  const vals = Object.keys(matches2).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches2[k];
    }
    return r;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}
class TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches2] = match(input, this.regex, this.handlers), [result2, zone, specificOffset] = matches2 ? dateTimeFromMatches(matches2) : [null, null, void 0];
      if (hasOwnProperty(matches2, "a") && hasOwnProperty(matches2, "H")) {
        throw new ConflictingSpecificationError(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches: matches2,
        result: result2,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
  const { result: result2, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result2, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
const INVALID = "Invalid DateTime";
const MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}
function clone$2(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [utcGuess, o];
  }
  utcGuess -= (o2 - o) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }
  return [localTS - Math.min(o2, o3) * 60 * 1e3, Math.max(o2, o3)];
}
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
    ...inst.c,
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }, millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return { ts, o };
}
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
      ...opts,
      zone: interpretationZone,
      specificOffset
    });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o, extended, precision) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (precision === "year") return c;
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    if (precision === "month") return c;
    c += "-";
  } else {
    c += padStart(o.c.month);
    if (precision === "month") return c;
  }
  c += padStart(o.c.day);
  return c;
}
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
  let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
  switch (precision) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      c += padStart(o.c.hour);
      if (precision === "hour") break;
      if (extended) {
        c += ":";
        c += padStart(o.c.minute);
        if (precision === "minute") break;
        if (showSeconds) {
          c += ":";
          c += padStart(o.c.second);
        }
      } else {
        c += padStart(o.c.minute);
        if (precision === "minute") break;
        if (showSeconds) {
          c += padStart(o.c.second);
        }
      }
      if (precision === "second") break;
      if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
        c += ".";
        c += padStart(o.c.millisecond, 3);
      }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
const defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"], orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
function guessOffsetForZone(zone) {
  if (zoneOffsetTs === void 0) {
    zoneOffsetTs = Settings.now();
  }
  if (zone.type !== "iana") {
    return zone.offset(zoneOffsetTs);
  }
  const zoneName = zone.name;
  let offsetGuess = zoneOffsetGuessCache.get(zoneName);
  if (offsetGuess === void 0) {
    offsetGuess = zone.offset(zoneOffsetTs);
    zoneOffsetGuessCache.set(zoneName, offsetGuess);
  }
  return offsetGuess;
}
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o;
  if (!isUndefined$2(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined$2(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({ ts, zone, loc, o });
}
function diffRelative(start, end, opts) {
  const round2 = isUndefined$2(opts.round) ? true : opts.round, rounding = isUndefined$2(opts.rounding) ? "trunc" : opts.rounding, format = (c, unit) => {
    c = roundTo(c, round2 || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  }, differ = (unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}
let zoneOffsetTs;
const zoneOffsetGuessCache = /* @__PURE__ */ new Map();
class DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined$2(config.ts) ? Settings.now() : config.ts;
    let c = null, o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        const ot = isNumber$1(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate$1(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber$1(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber$1(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined$2(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined$2(normalized.ordinal), containsGregorYear = !isUndefined$2(normalized.year), containsGregorMD = !isUndefined$2(normalized.month) || !isUndefined$2(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined$2(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    if (!inst.isValid) {
      return DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined$2(text) || isUndefined$2(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => t ? t.val : null).join("");
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
    }
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [clone$2(this, { ts: ts1 }), clone$2(this, { ts: ts2 })];
    }
    return [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone$2(this, { ts: newTS, zone });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone$2(this, { loc });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values2) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values2, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined$2(normalized.weekYear) || !isUndefined$2(normalized.weekNumber) || !isUndefined$2(normalized.weekday), containsOrdinal = !isUndefined$2(normalized.ordinal), containsGregorYear = !isUndefined$2(normalized.year), containsGregorMD = !isUndefined$2(normalized.month) || !isUndefined$2(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined$2(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined$2(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone$2(this, { ts, o });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone$2(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone$2(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit(precision);
    const ext = format === "extended";
    let c = toISODate(this, ext, precision);
    if (orderedUnits.indexOf(precision) >= 3) c += "T";
    c += toISOTime(
      this,
      ext,
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
    return c;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format = "extended", precision = "day" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended", normalizeUnit(precision));
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit(precision);
    let c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
    return c + toISOTime(
      this,
      format === "extended",
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined$2(text) || isUndefined$2(formatParser)) {
      throw new InvalidArgumentError(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(
        `fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`
      );
    }
    const { result: result2, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(
        result2,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber$1(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}
const VERSION = "3.7.2";
const timeZones = (countries) => {
  const zoneNames = Intl.supportedValuesOf("timeZone");
  return zoneNames.filter(
    (name) => Array.isArray(countries) && countries.length == 0 || (countries ?? []).some((x) => name.startsWith(x))
  ).filter((name) => IANAZone.isValidZone(name)).map((name) => IANAZone.create(name));
};
const fromISO = (dateTimeStr, tz) => DateTime.fromISO(dateTimeStr).setZone(tz ?? "utc", { keepLocalTime: true });
const toISO = (dt, destinationTz, sourceTz) => toDateTime(dt).setZone(sourceTz ?? SystemZone.instance.name, { keepLocalTime: true }).setZone(destinationTz ?? "utc", { keepLocalTime: false }).toISO({ includeOffset: false });
const formatDateTime = (dt, options) => formatWithOptions(dt, DateTime.DATETIME_SHORT, options);
const formatDate = (dt, options) => formatWithOptions(dt, DateTime.DATE_SHORT, options);
const formatTime = (dt, options) => formatWithOptions(dt, DateTime.TIME_SIMPLE, options);
const parseAndFormatDateTime = (dateTimeStr, sourceTz, options) => formatDateTime(fromISO(dateTimeStr, sourceTz), options);
const parseAndFormatDate = (dateTimeStr, sourceTz, options) => formatDate(fromISO(dateTimeStr, sourceTz), options);
const parseAndFormatTime = (dateTimeStr, sourceTz, options) => formatTime(fromISO(dateTimeStr, sourceTz), options);
const toDateTime = (dt) => {
  if (DateTime.isDateTime(dt)) {
    return dt;
  }
  if (dt instanceof Date) {
    return DateTime.fromJSDate(dt);
  }
  if (typeof dt === "string") {
    return DateTime.fromISO(dt);
  }
  throw new Error(
    "Provide either a luxon.DateTime, a native Date object, or an ISO formatted string"
  );
};
const formatWithOptions = (dt, defaultFormat, options) => dt.setZone(options?.tz ?? SystemZone.instance.name, { keepLocalTime: false }).toLocaleString(options?.format ?? defaultFormat);
const now$1 = DateTime.now();
const startOfCurrentMonth = toISO(now$1.startOf("month").startOf("day"));
const endOfCurrentMonth = toISO(now$1.endOf("month").endOf("day"));
var after_1;
var hasRequiredAfter;
function requireAfter() {
  if (hasRequiredAfter) return after_1;
  hasRequiredAfter = 1;
  function after2(closure, times2) {
    return function() {
      if (--times2 <= 0) closure();
    };
  }
  after_1 = after2;
  return after_1;
}
var afterExports = requireAfter();
const after = /* @__PURE__ */ getDefaultExportFromCjs(afterExports);
var now_1;
var hasRequiredNow;
function requireNow() {
  if (hasRequiredNow) return now_1;
  hasRequiredNow = 1;
  function now2() {
    return now2.get();
  }
  now2.get = typeof Date.now === "function" ? Date.now : function() {
    return +/* @__PURE__ */ new Date();
  };
  now_1 = now2;
  return now_1;
}
var timeout_1;
var hasRequiredTimeout;
function requireTimeout() {
  if (hasRequiredTimeout) return timeout_1;
  hasRequiredTimeout = 1;
  var slice2 = requireSlice();
  function timeout2(fn, millis, context) {
    var args = slice2(arguments, 3);
    return setTimeout(function() {
      fn.apply(context, args);
    }, millis);
  }
  timeout_1 = timeout2;
  return timeout_1;
}
var awaitDelay_1;
var hasRequiredAwaitDelay;
function requireAwaitDelay() {
  if (hasRequiredAwaitDelay) return awaitDelay_1;
  hasRequiredAwaitDelay = 1;
  var now2 = requireNow();
  var timeout2 = requireTimeout();
  var append2 = requireAppend();
  function awaitDelay2(callback, delay) {
    var baseTime = now2() + delay;
    return function() {
      var ms = Math.max(baseTime - now2(), 4);
      return timeout2.apply(this, append2([callback, ms, this], arguments));
    };
  }
  awaitDelay_1 = awaitDelay2;
  return awaitDelay_1;
}
var awaitDelayExports = requireAwaitDelay();
const awaitDelay = /* @__PURE__ */ getDefaultExportFromCjs(awaitDelayExports);
var bind_1;
var hasRequiredBind;
function requireBind() {
  if (hasRequiredBind) return bind_1;
  hasRequiredBind = 1;
  var slice2 = requireSlice();
  function bind2(fn, context, args) {
    var argsArr = slice2(arguments, 2);
    return function() {
      return fn.apply(context, argsArr.concat(slice2(arguments)));
    };
  }
  bind_1 = bind2;
  return bind_1;
}
var bindExports = requireBind();
const bind = /* @__PURE__ */ getDefaultExportFromCjs(bindExports);
var compose_1;
var hasRequiredCompose;
function requireCompose() {
  if (hasRequiredCompose) return compose_1;
  hasRequiredCompose = 1;
  function compose2() {
    var fns = arguments;
    return function(arg) {
      var n2 = fns.length;
      while (n2--) {
        arg = fns[n2].call(this, arg);
      }
      return arg;
    };
  }
  compose_1 = compose2;
  return compose_1;
}
var composeExports = requireCompose();
const compose = /* @__PURE__ */ getDefaultExportFromCjs(composeExports);
var constant_1;
var hasRequiredConstant;
function requireConstant() {
  if (hasRequiredConstant) return constant_1;
  hasRequiredConstant = 1;
  function constant2(value) {
    return function() {
      return value;
    };
  }
  constant_1 = constant2;
  return constant_1;
}
var constantExports = requireConstant();
const constant = /* @__PURE__ */ getDefaultExportFromCjs(constantExports);
var debounce_1;
var hasRequiredDebounce;
function requireDebounce() {
  if (hasRequiredDebounce) return debounce_1;
  hasRequiredDebounce = 1;
  function debounce2(fn, threshold, isAsap) {
    var timeout2, result2;
    function debounced() {
      var args = arguments, context = this;
      function delayed() {
        if (!isAsap) {
          result2 = fn.apply(context, args);
        }
        timeout2 = null;
      }
      if (timeout2) {
        clearTimeout(timeout2);
      } else if (isAsap) {
        result2 = fn.apply(context, args);
      }
      timeout2 = setTimeout(delayed, threshold);
      return result2;
    }
    debounced.cancel = function() {
      clearTimeout(timeout2);
    };
    return debounced;
  }
  debounce_1 = debounce2;
  return debounce_1;
}
var debounceExports = requireDebounce();
const debounce = /* @__PURE__ */ getDefaultExportFromCjs(debounceExports);
var func_1;
var hasRequiredFunc;
function requireFunc() {
  if (hasRequiredFunc) return func_1;
  hasRequiredFunc = 1;
  function func2(name) {
    return function(obj) {
      return obj[name]();
    };
  }
  func_1 = func2;
  return func_1;
}
var funcExports = requireFunc();
const func = /* @__PURE__ */ getDefaultExportFromCjs(funcExports);
var identityExports = requireIdentity();
const identity = /* @__PURE__ */ getDefaultExportFromCjs(identityExports);
var partial_1;
var hasRequiredPartial;
function requirePartial() {
  if (hasRequiredPartial) return partial_1;
  hasRequiredPartial = 1;
  var indexOf2 = requireIndexOf();
  var slice2 = requireSlice();
  var take2 = requireTake();
  var _ = {};
  function partial2(f) {
    var as = slice2(arguments, 1);
    var has_ = indexOf2(as, _) !== -1;
    return function() {
      var rest = slice2(arguments);
      var args = has_ ? take2(as.length, function(i) {
        var a = as[i];
        return a === _ ? rest.shift() : a;
      }) : as;
      return f.apply(this, rest.length ? args.concat(rest) : args);
    };
  }
  partial2._ = _;
  partial_1 = partial2;
  return partial_1;
}
var partialExports = requirePartial();
const partial = /* @__PURE__ */ getDefaultExportFromCjs(partialExports);
var propExports = requireProp();
const prop = /* @__PURE__ */ getDefaultExportFromCjs(propExports);
var series_1;
var hasRequiredSeries;
function requireSeries() {
  if (hasRequiredSeries) return series_1;
  hasRequiredSeries = 1;
  function series2() {
    var fns = arguments;
    return function() {
      var i = 0, n2 = fns.length;
      while (i < n2) {
        fns[i].apply(this, arguments);
        i += 1;
      }
    };
  }
  series_1 = series2;
  return series_1;
}
var seriesExports = requireSeries();
const series = /* @__PURE__ */ getDefaultExportFromCjs(seriesExports);
var throttle_1;
var hasRequiredThrottle;
function requireThrottle() {
  if (hasRequiredThrottle) return throttle_1;
  hasRequiredThrottle = 1;
  var now2 = requireNow();
  function throttle2(fn, delay) {
    var context, timeout2, result2, args, diff2, prevCall = 0;
    function delayed() {
      prevCall = now2();
      timeout2 = null;
      result2 = fn.apply(context, args);
    }
    function throttled() {
      context = this;
      args = arguments;
      diff2 = delay - (now2() - prevCall);
      if (diff2 <= 0) {
        clearTimeout(timeout2);
        delayed();
      } else if (!timeout2) {
        timeout2 = setTimeout(delayed, diff2);
      }
      return result2;
    }
    throttled.cancel = function() {
      clearTimeout(timeout2);
    };
    return throttled;
  }
  throttle_1 = throttle2;
  return throttle_1;
}
var throttleExports = requireThrottle();
const throttle = /* @__PURE__ */ getDefaultExportFromCjs(throttleExports);
var timeoutExports = requireTimeout();
const timeout = /* @__PURE__ */ getDefaultExportFromCjs(timeoutExports);
var times_1;
var hasRequiredTimes;
function requireTimes() {
  if (hasRequiredTimes) return times_1;
  hasRequiredTimes = 1;
  function times2(n2, callback, thisObj) {
    var i = -1;
    while (++i < n2) {
      if (callback.call(thisObj, i) === false) {
        break;
      }
    }
  }
  times_1 = times2;
  return times_1;
}
var timesExports = requireTimes();
const times = /* @__PURE__ */ getDefaultExportFromCjs(timesExports);
var wrap_1;
var hasRequiredWrap;
function requireWrap() {
  if (hasRequiredWrap) return wrap_1;
  hasRequiredWrap = 1;
  var partial2 = requirePartial();
  function wrap2(fn, wrapper) {
    return partial2(wrapper, fn);
  }
  wrap_1 = wrap2;
  return wrap_1;
}
var wrapExports = requireWrap();
const wrap = /* @__PURE__ */ getDefaultExportFromCjs(wrapExports);
var cloneExports = requireClone();
const clone = /* @__PURE__ */ getDefaultExportFromCjs(cloneExports);
var createObject_1;
var hasRequiredCreateObject;
function requireCreateObject() {
  if (hasRequiredCreateObject) return createObject_1;
  hasRequiredCreateObject = 1;
  var mixIn2 = requireMixIn();
  function createObject2(parent, props) {
    function F() {
    }
    F.prototype = parent;
    return mixIn2(new F(), props);
  }
  createObject_1 = createObject2;
  return createObject_1;
}
var createObjectExports = requireCreateObject();
const createObject = /* @__PURE__ */ getDefaultExportFromCjs(createObjectExports);
var ctorApply_1;
var hasRequiredCtorApply;
function requireCtorApply() {
  if (hasRequiredCtorApply) return ctorApply_1;
  hasRequiredCtorApply = 1;
  var bind2 = Function.prototype.bind;
  function ctorApply2(ctor, args) {
    var Bound = bind2.bind(ctor, void 0).apply(void 0, args);
    return new Bound();
  }
  ctorApply_1 = ctorApply2;
  return ctorApply_1;
}
var ctorApplyExports = requireCtorApply();
const ctorApply = /* @__PURE__ */ getDefaultExportFromCjs(ctorApplyExports);
var deepClone_1;
var hasRequiredDeepClone;
function requireDeepClone() {
  if (hasRequiredDeepClone) return deepClone_1;
  hasRequiredDeepClone = 1;
  var clone2 = requireClone();
  var forOwn2 = requireForOwn();
  var kindOf2 = requireKindOf();
  var isPlainObject2 = requireIsPlainObject();
  function deepClone2(val, instanceClone) {
    switch (kindOf2(val)) {
      case "Object":
        return cloneObject(val, instanceClone);
      case "Array":
        return cloneArray(val, instanceClone);
      default:
        return clone2(val);
    }
  }
  function cloneObject(source, instanceClone) {
    if (isPlainObject2(source)) {
      var out = {};
      forOwn2(source, function(val, key) {
        this[key] = deepClone2(val, instanceClone);
      }, out);
      return out;
    } else if (instanceClone) {
      return instanceClone(source);
    } else {
      return source;
    }
  }
  function cloneArray(arr, instanceClone) {
    var out = [], i = -1, n2 = arr.length;
    while (++i < n2) {
      out[i] = deepClone2(arr[i], instanceClone);
    }
    return out;
  }
  deepClone_1 = deepClone2;
  return deepClone_1;
}
var deepCloneExports = requireDeepClone();
const deepClone = /* @__PURE__ */ getDefaultExportFromCjs(deepCloneExports);
var equals_1;
var hasRequiredEquals;
function requireEquals() {
  if (hasRequiredEquals) return equals_1;
  hasRequiredEquals = 1;
  var hasOwn2 = requireHasOwn();
  var every2 = requireEvery$1();
  var isObject2 = requireIsObject();
  var is2 = requireIs();
  function makeCompare(callback) {
    return function(value, key) {
      return hasOwn2(this, key) && callback(value, this[key]);
    };
  }
  function checkProperties(value, key) {
    return hasOwn2(this, key);
  }
  function equals2(a, b, callback) {
    callback = callback || is2;
    if (!isObject2(a) || !isObject2(b)) {
      return callback(a, b);
    }
    return every2(a, makeCompare(callback), b) && every2(b, checkProperties, a);
  }
  equals_1 = equals2;
  return equals_1;
}
var deepEquals_1;
var hasRequiredDeepEquals;
function requireDeepEquals() {
  if (hasRequiredDeepEquals) return deepEquals_1;
  hasRequiredDeepEquals = 1;
  var is2 = requireIs();
  var isObject2 = requireIsObject();
  var isArray2 = requireIsArray();
  var objEquals = requireEquals();
  var arrEquals = requireEquals$1();
  function deepEquals2(a, b, callback) {
    callback = callback || is2;
    var bothObjects = isObject2(a) && isObject2(b);
    var bothArrays = !bothObjects && isArray2(a) && isArray2(b);
    if (!bothObjects && !bothArrays) {
      return callback(a, b);
    }
    function compare(a2, b2) {
      return deepEquals2(a2, b2, callback);
    }
    var method = bothObjects ? objEquals : arrEquals;
    return method(a, b, compare);
  }
  deepEquals_1 = deepEquals2;
  return deepEquals_1;
}
var deepEqualsExports = requireDeepEquals();
const deepEquals = /* @__PURE__ */ getDefaultExportFromCjs(deepEqualsExports);
var GLOBAL$1;
var hasRequiredGLOBAL;
function requireGLOBAL() {
  if (hasRequiredGLOBAL) return GLOBAL$1;
  hasRequiredGLOBAL = 1;
  GLOBAL$1 = Function("return this")();
  return GLOBAL$1;
}
var toArray_1;
var hasRequiredToArray;
function requireToArray() {
  if (hasRequiredToArray) return toArray_1;
  hasRequiredToArray = 1;
  var kindOf2 = requireKindOf();
  var GLOBAL2 = requireGLOBAL();
  function toArray2(val) {
    var ret = [], kind = kindOf2(val), n2;
    if (val != null) {
      if (val.length == null || kind === "String" || kind === "Function" || kind === "RegExp" || val === GLOBAL2) {
        ret[ret.length] = val;
      } else {
        n2 = val.length;
        while (n2--) {
          ret[n2] = val[n2];
        }
      }
    }
    return ret;
  }
  toArray_1 = toArray2;
  return toArray_1;
}
var defaults_1;
var hasRequiredDefaults;
function requireDefaults() {
  if (hasRequiredDefaults) return defaults_1;
  hasRequiredDefaults = 1;
  var toArray2 = requireToArray();
  var find2 = requireFind$2();
  function defaults2(var_args) {
    return find2(toArray2(arguments), nonVoid);
  }
  function nonVoid(val) {
    return val != null;
  }
  defaults_1 = defaults2;
  return defaults_1;
}
var defaultsExports = requireDefaults();
const defaults = /* @__PURE__ */ getDefaultExportFromCjs(defaultsExports);
var GLOBALExports = requireGLOBAL();
const GLOBAL = /* @__PURE__ */ getDefaultExportFromCjs(GLOBALExports);
var inheritPrototype_1;
var hasRequiredInheritPrototype;
function requireInheritPrototype() {
  if (hasRequiredInheritPrototype) return inheritPrototype_1;
  hasRequiredInheritPrototype = 1;
  var createObject2 = requireCreateObject();
  function inheritPrototype2(child, parent) {
    var p = createObject2(parent.prototype);
    p.constructor = child;
    child.prototype = p;
    child.super_ = parent;
    return p;
  }
  inheritPrototype_1 = inheritPrototype2;
  return inheritPrototype_1;
}
var inheritPrototypeExports = requireInheritPrototype();
const inheritPrototype = /* @__PURE__ */ getDefaultExportFromCjs(inheritPrototypeExports);
var isExports = requireIs();
const is = /* @__PURE__ */ getDefaultExportFromCjs(isExports);
var isnt_1;
var hasRequiredIsnt;
function requireIsnt() {
  if (hasRequiredIsnt) return isnt_1;
  hasRequiredIsnt = 1;
  var is2 = requireIs();
  function isnt2(x, y) {
    return !is2(x, y);
  }
  isnt_1 = isnt2;
  return isnt_1;
}
var isntExports = requireIsnt();
const isnt = /* @__PURE__ */ getDefaultExportFromCjs(isntExports);
var isArrayExports = requireIsArray();
const isArray = /* @__PURE__ */ getDefaultExportFromCjs(isArrayExports);
var isBoolean_1;
var hasRequiredIsBoolean;
function requireIsBoolean() {
  if (hasRequiredIsBoolean) return isBoolean_1;
  hasRequiredIsBoolean = 1;
  var isKind2 = requireIsKind();
  function isBoolean2(val) {
    return isKind2(val, "Boolean");
  }
  isBoolean_1 = isBoolean2;
  return isBoolean_1;
}
var isBooleanExports = requireIsBoolean();
const isBoolean = /* @__PURE__ */ getDefaultExportFromCjs(isBooleanExports);
var isDateExports = requireIsDate();
const isDate = /* @__PURE__ */ getDefaultExportFromCjs(isDateExports);
var isEmpty_1;
var hasRequiredIsEmpty;
function requireIsEmpty() {
  if (hasRequiredIsEmpty) return isEmpty_1;
  hasRequiredIsEmpty = 1;
  var forOwn2 = requireForOwn();
  var isArray2 = requireIsArray();
  function isEmpty2(val) {
    if (val == null) {
      return true;
    } else if (typeof val === "string" || isArray2(val)) {
      return !val.length;
    } else if (typeof val === "object") {
      var result2 = true;
      forOwn2(val, function() {
        result2 = false;
        return false;
      });
      return result2;
    } else {
      return true;
    }
  }
  isEmpty_1 = isEmpty2;
  return isEmpty_1;
}
var isEmptyExports = requireIsEmpty();
const isEmpty = /* @__PURE__ */ getDefaultExportFromCjs(isEmptyExports);
var isNumber_1;
var hasRequiredIsNumber;
function requireIsNumber() {
  if (hasRequiredIsNumber) return isNumber_1;
  hasRequiredIsNumber = 1;
  var isKind2 = requireIsKind();
  function isNumber2(val) {
    return isKind2(val, "Number");
  }
  isNumber_1 = isNumber2;
  return isNumber_1;
}
var _isFinite;
var hasRequired_isFinite;
function require_isFinite() {
  if (hasRequired_isFinite) return _isFinite;
  hasRequired_isFinite = 1;
  var isNumber2 = requireIsNumber();
  var GLOBAL2 = requireGLOBAL();
  function isFinite2(val) {
    var is2 = false;
    if (typeof val === "string" && val !== "") {
      is2 = GLOBAL2.isFinite(parseFloat(val));
    } else if (isNumber2(val)) {
      is2 = GLOBAL2.isFinite(val);
    }
    return is2;
  }
  _isFinite = isFinite2;
  return _isFinite;
}
var _isFiniteExports = require_isFinite();
const isFinite = /* @__PURE__ */ getDefaultExportFromCjs(_isFiniteExports);
var isFunctionExports = requireIsFunction();
const isFunction = /* @__PURE__ */ getDefaultExportFromCjs(isFunctionExports);
var isKindExports = requireIsKind();
const isKind = /* @__PURE__ */ getDefaultExportFromCjs(isKindExports);
var isInteger_1;
var hasRequiredIsInteger;
function requireIsInteger() {
  if (hasRequiredIsInteger) return isInteger_1;
  hasRequiredIsInteger = 1;
  var isNumber2 = requireIsNumber();
  function isInteger2(val) {
    return isNumber2(val) && val % 1 === 0;
  }
  isInteger_1 = isInteger2;
  return isInteger_1;
}
var isIntegerExports = requireIsInteger();
const isInteger = /* @__PURE__ */ getDefaultExportFromCjs(isIntegerExports);
var _isNaN$1;
var hasRequired_isNaN$1;
function require_isNaN$1() {
  if (hasRequired_isNaN$1) return _isNaN$1;
  hasRequired_isNaN$1 = 1;
  function isNaN2(val) {
    return typeof val === "number" && val != val;
  }
  _isNaN$1 = isNaN2;
  return _isNaN$1;
}
var _isNaN;
var hasRequired_isNaN;
function require_isNaN() {
  if (hasRequired_isNaN) return _isNaN;
  hasRequired_isNaN = 1;
  var isNumber2 = requireIsNumber();
  var $isNaN = require_isNaN$1();
  function isNaN2(val) {
    return !isNumber2(val) || $isNaN(Number(val));
  }
  _isNaN = isNaN2;
  return _isNaN;
}
var _isNaNExports$1 = require_isNaN();
const isNaN$2 = /* @__PURE__ */ getDefaultExportFromCjs(_isNaNExports$1);
var isNull_1;
var hasRequiredIsNull;
function requireIsNull() {
  if (hasRequiredIsNull) return isNull_1;
  hasRequiredIsNull = 1;
  function isNull2(val) {
    return val === null;
  }
  isNull_1 = isNull2;
  return isNull_1;
}
var isNullExports = requireIsNull();
const isNull = /* @__PURE__ */ getDefaultExportFromCjs(isNullExports);
var isNumberExports = requireIsNumber();
const isNumber = /* @__PURE__ */ getDefaultExportFromCjs(isNumberExports);
var isObjectExports = requireIsObject();
const isObject = /* @__PURE__ */ getDefaultExportFromCjs(isObjectExports);
var isPlainObjectExports = requireIsPlainObject();
const isPlainObject = /* @__PURE__ */ getDefaultExportFromCjs(isPlainObjectExports);
var isRegExp_1;
var hasRequiredIsRegExp;
function requireIsRegExp() {
  if (hasRequiredIsRegExp) return isRegExp_1;
  hasRequiredIsRegExp = 1;
  var isKind2 = requireIsKind();
  function isRegExp2(val) {
    return isKind2(val, "RegExp");
  }
  isRegExp_1 = isRegExp2;
  return isRegExp_1;
}
var isRegExpExports = requireIsRegExp();
const isRegExp = /* @__PURE__ */ getDefaultExportFromCjs(isRegExpExports);
var isString_1;
var hasRequiredIsString;
function requireIsString() {
  if (hasRequiredIsString) return isString_1;
  hasRequiredIsString = 1;
  var isKind2 = requireIsKind();
  function isString2(val) {
    return isKind2(val, "String");
  }
  isString_1 = isString2;
  return isString_1;
}
var isStringExports = requireIsString();
const isString = /* @__PURE__ */ getDefaultExportFromCjs(isStringExports);
var isUndefined$1;
var hasRequiredIsUndefined;
function requireIsUndefined() {
  if (hasRequiredIsUndefined) return isUndefined$1;
  hasRequiredIsUndefined = 1;
  var UNDEF;
  function isUndef(val) {
    return val === UNDEF;
  }
  isUndefined$1 = isUndef;
  return isUndefined$1;
}
var isUndefinedExports = requireIsUndefined();
const isUndefined = /* @__PURE__ */ getDefaultExportFromCjs(isUndefinedExports);
var kindOfExports = requireKindOf();
const kindOf = /* @__PURE__ */ getDefaultExportFromCjs(kindOfExports);
var toArrayExports = requireToArray();
const toArray = /* @__PURE__ */ getDefaultExportFromCjs(toArrayExports);
var toNumberExports = requireToNumber();
const toNumber = /* @__PURE__ */ getDefaultExportFromCjs(toNumberExports);
var toStringExports = requireToString();
const toString = /* @__PURE__ */ getDefaultExportFromCjs(toStringExports);
var ceil_1;
var hasRequiredCeil;
function requireCeil() {
  if (hasRequiredCeil) return ceil_1;
  hasRequiredCeil = 1;
  function ceil2(val, step) {
    step = Math.abs(step || 1);
    return Math.ceil(val / step) * step;
  }
  ceil_1 = ceil2;
  return ceil_1;
}
var ceilExports = requireCeil();
const ceil = /* @__PURE__ */ getDefaultExportFromCjs(ceilExports);
var clamp_1;
var hasRequiredClamp;
function requireClamp() {
  if (hasRequiredClamp) return clamp_1;
  hasRequiredClamp = 1;
  function clamp2(val, min2, max2) {
    return val < min2 ? min2 : val > max2 ? max2 : val;
  }
  clamp_1 = clamp2;
  return clamp_1;
}
var clampExports = requireClamp();
const clamp = /* @__PURE__ */ getDefaultExportFromCjs(clampExports);
var countStepsExports = requireCountSteps();
const countSteps = /* @__PURE__ */ getDefaultExportFromCjs(countStepsExports);
var floor_1;
var hasRequiredFloor;
function requireFloor() {
  if (hasRequiredFloor) return floor_1;
  hasRequiredFloor = 1;
  function floor2(val, step) {
    step = Math.abs(step || 1);
    return Math.floor(val / step) * step;
  }
  floor_1 = floor2;
  return floor_1;
}
var floorExports = requireFloor();
const floor = /* @__PURE__ */ getDefaultExportFromCjs(floorExports);
var inRange_1;
var hasRequiredInRange;
function requireInRange() {
  if (hasRequiredInRange) return inRange_1;
  hasRequiredInRange = 1;
  function inRange2(val, min2, max2, threshold) {
    threshold = threshold || 0;
    return val + threshold >= min2 && val - threshold <= max2;
  }
  inRange_1 = inRange2;
  return inRange_1;
}
var inRangeExports = requireInRange();
const inRange = /* @__PURE__ */ getDefaultExportFromCjs(inRangeExports);
var isNear_1;
var hasRequiredIsNear;
function requireIsNear() {
  if (hasRequiredIsNear) return isNear_1;
  hasRequiredIsNear = 1;
  function isNear2(val, target, threshold) {
    return Math.abs(val - target) <= threshold;
  }
  isNear_1 = isNear2;
  return isNear_1;
}
var isNearExports = requireIsNear();
const isNear = /* @__PURE__ */ getDefaultExportFromCjs(isNearExports);
var lerp_1;
var hasRequiredLerp;
function requireLerp() {
  if (hasRequiredLerp) return lerp_1;
  hasRequiredLerp = 1;
  function lerp2(ratio, start, end) {
    return start + (end - start) * ratio;
  }
  lerp_1 = lerp2;
  return lerp_1;
}
var lerpExports = requireLerp();
const lerp = /* @__PURE__ */ getDefaultExportFromCjs(lerpExports);
var loop_1;
var hasRequiredLoop;
function requireLoop() {
  if (hasRequiredLoop) return loop_1;
  hasRequiredLoop = 1;
  function loop2(val, min2, max2) {
    return val < min2 ? max2 : val > max2 ? min2 : val;
  }
  loop_1 = loop2;
  return loop_1;
}
var loopExports = requireLoop();
const loop = /* @__PURE__ */ getDefaultExportFromCjs(loopExports);
var norm_1;
var hasRequiredNorm;
function requireNorm() {
  if (hasRequiredNorm) return norm_1;
  hasRequiredNorm = 1;
  function norm2(val, min2, max2) {
    if (val < min2 || val > max2) {
      throw new RangeError("value (" + val + ") must be between " + min2 + " and " + max2);
    }
    return val === max2 ? 1 : (val - min2) / (max2 - min2);
  }
  norm_1 = norm2;
  return norm_1;
}
var map_1;
var hasRequiredMap$1;
function requireMap$1() {
  if (hasRequiredMap$1) return map_1;
  hasRequiredMap$1 = 1;
  var lerp2 = requireLerp();
  var norm2 = requireNorm();
  function map2(val, min1, max1, min2, max2) {
    return lerp2(norm2(val, min1, max1), min2, max2);
  }
  map_1 = map2;
  return map_1;
}
var mapExports$1 = requireMap$1();
const map$2 = /* @__PURE__ */ getDefaultExportFromCjs(mapExports$1);
var normExports = requireNorm();
const norm = /* @__PURE__ */ getDefaultExportFromCjs(normExports);
var round_1;
var hasRequiredRound;
function requireRound() {
  if (hasRequiredRound) return round_1;
  hasRequiredRound = 1;
  function round2(value, radix) {
    radix = radix || 1;
    return Math.round(value / radix) * radix;
  }
  round_1 = round2;
  return round_1;
}
var roundExports = requireRound();
const round = /* @__PURE__ */ getDefaultExportFromCjs(roundExports);
var enforcePrecision_1;
var hasRequiredEnforcePrecision;
function requireEnforcePrecision() {
  if (hasRequiredEnforcePrecision) return enforcePrecision_1;
  hasRequiredEnforcePrecision = 1;
  var toNumber2 = requireToNumber();
  function enforcePrecision2(val, nDecimalDigits) {
    val = toNumber2(val);
    var pow = Math.pow(10, nDecimalDigits);
    return +(Math.round(val * pow) / pow).toFixed(nDecimalDigits);
  }
  enforcePrecision_1 = enforcePrecision2;
  return enforcePrecision_1;
}
var abbreviate$1;
var hasRequiredAbbreviate;
function requireAbbreviate() {
  if (hasRequiredAbbreviate) return abbreviate$1;
  hasRequiredAbbreviate = 1;
  var enforcePrecision2 = requireEnforcePrecision();
  var _defaultDict = {
    thousand: "K",
    million: "M",
    billion: "B"
  };
  function abbreviateNumber(val, nDecimals, dict) {
    nDecimals = nDecimals != null ? nDecimals : 1;
    dict = dict || _defaultDict;
    val = enforcePrecision2(val, nDecimals);
    var str, mod;
    var negative = false;
    if (val < 0) {
      val = -val;
      negative = true;
    }
    if (val < 1e6) {
      mod = enforcePrecision2(val / 1e3, nDecimals);
      str = mod < 1e3 ? mod + dict.thousand : 1 + dict.million;
    } else if (val < 1e9) {
      mod = enforcePrecision2(val / 1e6, nDecimals);
      str = mod < 1e3 ? mod + dict.million : 1 + dict.billion;
    } else {
      str = enforcePrecision2(val / 1e9, nDecimals) + dict.billion;
    }
    if (negative) {
      str = "-" + str;
    }
    return str;
  }
  abbreviate$1 = abbreviateNumber;
  return abbreviate$1;
}
var abbreviateExports = requireAbbreviate();
const abbreviate = /* @__PURE__ */ getDefaultExportFromCjs(abbreviateExports);
var currencyFormat_1;
var hasRequiredCurrencyFormat;
function requireCurrencyFormat() {
  if (hasRequiredCurrencyFormat) return currencyFormat_1;
  hasRequiredCurrencyFormat = 1;
  var toNumber2 = requireToNumber();
  function currencyFormat2(val, nDecimalDigits, decimalSeparator, thousandsSeparator) {
    val = toNumber2(val);
    nDecimalDigits = nDecimalDigits == null ? 2 : nDecimalDigits;
    decimalSeparator = decimalSeparator == null ? "." : decimalSeparator;
    thousandsSeparator = thousandsSeparator == null ? "," : thousandsSeparator;
    var fixed = val.toFixed(nDecimalDigits), parts = new RegExp("^(-?\\d{1,3})((?:\\d{3})+)(\\.(\\d{" + nDecimalDigits + "}))?$").exec(fixed);
    if (parts) {
      return parts[1] + parts[2].replace(/\d{3}/g, thousandsSeparator + "$&") + (parts[4] ? decimalSeparator + parts[4] : "");
    } else {
      return fixed.replace(".", decimalSeparator);
    }
  }
  currencyFormat_1 = currencyFormat2;
  return currencyFormat_1;
}
var currencyFormatExports = requireCurrencyFormat();
const currencyFormat = /* @__PURE__ */ getDefaultExportFromCjs(currencyFormatExports);
var enforcePrecisionExports = requireEnforcePrecision();
const enforcePrecision = /* @__PURE__ */ getDefaultExportFromCjs(enforcePrecisionExports);
var _isNaNExports = require_isNaN$1();
const isNaN$1 = /* @__PURE__ */ getDefaultExportFromCjs(_isNaNExports);
var MAX_INTExports = requireMAX_INT();
const MAX_INT = /* @__PURE__ */ getDefaultExportFromCjs(MAX_INTExports);
var MAX_SAFE_INTEGER$1;
var hasRequiredMAX_SAFE_INTEGER;
function requireMAX_SAFE_INTEGER() {
  if (hasRequiredMAX_SAFE_INTEGER) return MAX_SAFE_INTEGER$1;
  hasRequiredMAX_SAFE_INTEGER = 1;
  MAX_SAFE_INTEGER$1 = 9007199254740991;
  return MAX_SAFE_INTEGER$1;
}
var MAX_SAFE_INTEGERExports = requireMAX_SAFE_INTEGER();
const MAX_SAFE_INTEGER = /* @__PURE__ */ getDefaultExportFromCjs(MAX_SAFE_INTEGERExports);
var MAX_UINT$1;
var hasRequiredMAX_UINT;
function requireMAX_UINT() {
  if (hasRequiredMAX_UINT) return MAX_UINT$1;
  hasRequiredMAX_UINT = 1;
  MAX_UINT$1 = 4294967295;
  return MAX_UINT$1;
}
var MAX_UINTExports = requireMAX_UINT();
const MAX_UINT = /* @__PURE__ */ getDefaultExportFromCjs(MAX_UINTExports);
var MIN_INTExports = requireMIN_INT();
const MIN_INT = /* @__PURE__ */ getDefaultExportFromCjs(MIN_INTExports);
var nth_1;
var hasRequiredNth;
function requireNth() {
  if (hasRequiredNth) return nth_1;
  hasRequiredNth = 1;
  function nth2(i) {
    var t = i % 100;
    if (t >= 10 && t <= 20) {
      return "th";
    }
    switch (i % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  nth_1 = nth2;
  return nth_1;
}
var nthExports = requireNth();
const nth = /* @__PURE__ */ getDefaultExportFromCjs(nthExports);
var ordinal_1;
var hasRequiredOrdinal;
function requireOrdinal() {
  if (hasRequiredOrdinal) return ordinal_1;
  hasRequiredOrdinal = 1;
  var toInt2 = requireToInt();
  var nth2 = requireNth();
  function ordinal2(n2) {
    n2 = toInt2(n2);
    return n2 + nth2(n2);
  }
  ordinal_1 = ordinal2;
  return ordinal_1;
}
var ordinalExports = requireOrdinal();
const ordinal = /* @__PURE__ */ getDefaultExportFromCjs(ordinalExports);
var padExports = requirePad();
const pad = /* @__PURE__ */ getDefaultExportFromCjs(padExports);
var rol_1;
var hasRequiredRol;
function requireRol() {
  if (hasRequiredRol) return rol_1;
  hasRequiredRol = 1;
  function rol2(val, shift) {
    return val << shift | val >> 32 - shift;
  }
  rol_1 = rol2;
  return rol_1;
}
var rolExports = requireRol();
const rol = /* @__PURE__ */ getDefaultExportFromCjs(rolExports);
var ror_1;
var hasRequiredRor;
function requireRor() {
  if (hasRequiredRor) return ror_1;
  hasRequiredRor = 1;
  function ror2(val, shift) {
    return val >> shift | val << 32 - shift;
  }
  ror_1 = ror2;
  return ror_1;
}
var rorExports = requireRor();
const ror = /* @__PURE__ */ getDefaultExportFromCjs(rorExports);
var sign_1;
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign_1;
  hasRequiredSign = 1;
  var toNumber2 = requireToNumber();
  function sign2(val) {
    var num = toNumber2(val);
    if (num === 0) return num;
    if (isNaN(num)) return num;
    return num < 0 ? -1 : 1;
  }
  sign_1 = sign2;
  return sign_1;
}
var signExports = requireSign();
const sign = /* @__PURE__ */ getDefaultExportFromCjs(signExports);
var toIntExports = requireToInt();
const toInt = /* @__PURE__ */ getDefaultExportFromCjs(toIntExports);
var toUInt_1;
var hasRequiredToUInt;
function requireToUInt() {
  if (hasRequiredToUInt) return toUInt_1;
  hasRequiredToUInt = 1;
  function toUInt2(val) {
    return val >>> 0;
  }
  toUInt_1 = toUInt2;
  return toUInt_1;
}
var toUIntExports = requireToUInt();
const toUInt = /* @__PURE__ */ getDefaultExportFromCjs(toUIntExports);
var toUInt31_1;
var hasRequiredToUInt31;
function requireToUInt31() {
  if (hasRequiredToUInt31) return toUInt31_1;
  hasRequiredToUInt31 = 1;
  var MAX_INT2 = requireMAX_INT();
  function toUInt312(val) {
    return val <= 0 ? 0 : val > MAX_INT2 ? ~~(val % (MAX_INT2 + 1)) : ~~val;
  }
  toUInt31_1 = toUInt312;
  return toUInt31_1;
}
var toUInt31Exports = requireToUInt31();
const toUInt31 = /* @__PURE__ */ getDefaultExportFromCjs(toUInt31Exports);
const formatCurrencyUSD = (amount) => {
  return new Intl.NumberFormat(navigator.language, {
    style: "currency",
    currency: "USD"
  }).format(Number(amount) || 0);
};
var functions_1;
var hasRequiredFunctions;
function requireFunctions() {
  if (hasRequiredFunctions) return functions_1;
  hasRequiredFunctions = 1;
  var forIn2 = requireForIn();
  function functions2(obj) {
    var keys2 = [];
    forIn2(obj, function(val, key) {
      if (typeof val === "function") {
        keys2.push(key);
      }
    });
    return keys2.sort();
  }
  functions_1 = functions2;
  return functions_1;
}
var bindAll_1;
var hasRequiredBindAll;
function requireBindAll() {
  if (hasRequiredBindAll) return bindAll_1;
  hasRequiredBindAll = 1;
  var functions2 = requireFunctions();
  var bind2 = requireBind();
  var forEach2 = requireForEach$1();
  var slice2 = requireSlice();
  function bindAll2(obj, rest_methodNames) {
    var keys2 = arguments.length > 1 ? slice2(arguments, 1) : functions2(obj);
    forEach2(keys2, function(key) {
      obj[key] = bind2(obj[key], obj);
    });
  }
  bindAll_1 = bindAll2;
  return bindAll_1;
}
var bindAllExports = requireBindAll();
const bindAll = /* @__PURE__ */ getDefaultExportFromCjs(bindAllExports);
var containsExports$2 = requireContains$3();
const contains$2 = /* @__PURE__ */ getDefaultExportFromCjs(containsExports$2);
var deepFillIn_1;
var hasRequiredDeepFillIn;
function requireDeepFillIn() {
  if (hasRequiredDeepFillIn) return deepFillIn_1;
  hasRequiredDeepFillIn = 1;
  var forOwn2 = requireForOwn();
  var isPlainObject2 = requireIsPlainObject();
  function deepFillIn2(target, defaults2) {
    var i = 0, n2 = arguments.length, obj;
    while (++i < n2) {
      obj = arguments[i];
      if (obj) {
        forOwn2(obj, function(newValue, key) {
          var curValue = target[key];
          if (curValue == null) {
            target[key] = newValue;
          } else if (isPlainObject2(curValue) && isPlainObject2(newValue)) {
            deepFillIn2(curValue, newValue);
          }
        });
      }
    }
    return target;
  }
  deepFillIn_1 = deepFillIn2;
  return deepFillIn_1;
}
var deepFillInExports = requireDeepFillIn();
const deepFillIn = /* @__PURE__ */ getDefaultExportFromCjs(deepFillInExports);
var deepMatchesExports = requireDeepMatches();
const deepMatches = /* @__PURE__ */ getDefaultExportFromCjs(deepMatchesExports);
var deepMixIn_1;
var hasRequiredDeepMixIn;
function requireDeepMixIn() {
  if (hasRequiredDeepMixIn) return deepMixIn_1;
  hasRequiredDeepMixIn = 1;
  var forOwn2 = requireForOwn();
  var isPlainObject2 = requireIsPlainObject();
  function deepMixIn2(target, objects) {
    var i = 0, n2 = arguments.length, obj;
    while (++i < n2) {
      obj = arguments[i];
      if (obj) {
        forOwn2(obj, copyProp, target);
      }
    }
    return target;
  }
  function copyProp(val, key) {
    var existing = this[key];
    if (isPlainObject2(val) && isPlainObject2(existing)) {
      deepMixIn2(existing, val);
    } else {
      this[key] = val;
    }
  }
  deepMixIn_1 = deepMixIn2;
  return deepMixIn_1;
}
var deepMixInExports = requireDeepMixIn();
const deepMixIn = /* @__PURE__ */ getDefaultExportFromCjs(deepMixInExports);
var equalsExports = requireEquals();
const equals = /* @__PURE__ */ getDefaultExportFromCjs(equalsExports);
var everyExports = requireEvery$1();
const every = /* @__PURE__ */ getDefaultExportFromCjs(everyExports);
var fillIn_1;
var hasRequiredFillIn;
function requireFillIn() {
  if (hasRequiredFillIn) return fillIn_1;
  hasRequiredFillIn = 1;
  var forEach2 = requireForEach$1();
  var slice2 = requireSlice();
  var forOwn2 = requireForOwn();
  function fillIn2(obj, var_defaults) {
    forEach2(slice2(arguments, 1), function(base) {
      forOwn2(base, function(val, key) {
        if (obj[key] == null) {
          obj[key] = val;
        }
      });
    });
    return obj;
  }
  fillIn_1 = fillIn2;
  return fillIn_1;
}
var fillInExports = requireFillIn();
const fillIn = /* @__PURE__ */ getDefaultExportFromCjs(fillInExports);
var filter$1;
var hasRequiredFilter;
function requireFilter() {
  if (hasRequiredFilter) return filter$1;
  hasRequiredFilter = 1;
  var forOwn2 = requireForOwn();
  var makeIterator = requireMakeIterator_();
  function filterValues(obj, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var output = {};
    forOwn2(obj, function(value, key, obj2) {
      if (callback(value, key, obj2)) {
        output[key] = value;
      }
    });
    return output;
  }
  filter$1 = filterValues;
  return filter$1;
}
var filterExports = requireFilter();
const filter = /* @__PURE__ */ getDefaultExportFromCjs(filterExports);
var findExports = requireFind$1();
const find = /* @__PURE__ */ getDefaultExportFromCjs(findExports);
var forInExports = requireForIn();
const forIn = /* @__PURE__ */ getDefaultExportFromCjs(forInExports);
var forOwnExports = requireForOwn();
const forOwn = /* @__PURE__ */ getDefaultExportFromCjs(forOwnExports);
var functionsExports = requireFunctions();
const functions = /* @__PURE__ */ getDefaultExportFromCjs(functionsExports);
var get_1;
var hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get_1;
  hasRequiredGet = 1;
  function get2(obj, prop2) {
    if (!obj) return;
    var parts = prop2.split("."), last2 = parts.pop();
    while (prop2 = parts.shift()) {
      obj = obj[prop2];
      if (obj == null) return;
    }
    return obj[last2];
  }
  get_1 = get2;
  return get_1;
}
var getExports = requireGet();
const get = /* @__PURE__ */ getDefaultExportFromCjs(getExports);
var has_1;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has_1;
  hasRequiredHas = 1;
  var get2 = requireGet();
  var UNDEF;
  function has2(obj, prop2) {
    return get2(obj, prop2) !== UNDEF;
  }
  has_1 = has2;
  return has_1;
}
var hasExports = requireHas();
const has = /* @__PURE__ */ getDefaultExportFromCjs(hasExports);
var hasOwnExports = requireHasOwn();
const hasOwn = /* @__PURE__ */ getDefaultExportFromCjs(hasOwnExports);
var keys_1;
var hasRequiredKeys;
function requireKeys() {
  if (hasRequiredKeys) return keys_1;
  hasRequiredKeys = 1;
  var forOwn2 = requireForOwn();
  var keys2 = Object.keys || function(obj) {
    var keys3 = [];
    forOwn2(obj, function(val, key) {
      keys3.push(key);
    });
    return keys3;
  };
  keys_1 = keys2;
  return keys_1;
}
var keysExports = requireKeys();
const keys = /* @__PURE__ */ getDefaultExportFromCjs(keysExports);
var map$1;
var hasRequiredMap;
function requireMap() {
  if (hasRequiredMap) return map$1;
  hasRequiredMap = 1;
  var forOwn2 = requireForOwn();
  var makeIterator = requireMakeIterator_();
  function mapValues(obj, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    var output = {};
    forOwn2(obj, function(val, key, obj2) {
      output[key] = callback(val, key, obj2);
    });
    return output;
  }
  map$1 = mapValues;
  return map$1;
}
var mapExports = requireMap();
const map = /* @__PURE__ */ getDefaultExportFromCjs(mapExports);
var matches_1;
var hasRequiredMatches;
function requireMatches() {
  if (hasRequiredMatches) return matches_1;
  hasRequiredMatches = 1;
  var forOwn2 = requireForOwn();
  function matches2(target, props) {
    var result2 = true;
    forOwn2(props, function(val, key) {
      if (target[key] !== val) {
        return result2 = false;
      }
    });
    return result2;
  }
  matches_1 = matches2;
  return matches_1;
}
var matchesExports = requireMatches();
const matches = /* @__PURE__ */ getDefaultExportFromCjs(matchesExports);
var merge_1;
var hasRequiredMerge;
function requireMerge() {
  if (hasRequiredMerge) return merge_1;
  hasRequiredMerge = 1;
  var hasOwn2 = requireHasOwn();
  var deepClone2 = requireDeepClone();
  var isObject2 = requireIsObject();
  function merge2() {
    var i = 1, key, val, obj, target;
    target = deepClone2(arguments[0]);
    while (obj = arguments[i++]) {
      for (key in obj) {
        if (!hasOwn2(obj, key)) {
          continue;
        }
        val = obj[key];
        if (isObject2(val) && isObject2(target[key])) {
          target[key] = merge2(target[key], val);
        } else {
          target[key] = deepClone2(val);
        }
      }
    }
    return target;
  }
  merge_1 = merge2;
  return merge_1;
}
var mergeExports = requireMerge();
const merge = /* @__PURE__ */ getDefaultExportFromCjs(mergeExports);
var maxExports = requireMax$1();
const max = /* @__PURE__ */ getDefaultExportFromCjs(maxExports);
var minExports = requireMin$1();
const min = /* @__PURE__ */ getDefaultExportFromCjs(minExports);
var mixInExports = requireMixIn();
const mixIn = /* @__PURE__ */ getDefaultExportFromCjs(mixInExports);
var namespace_1;
var hasRequiredNamespace;
function requireNamespace() {
  if (hasRequiredNamespace) return namespace_1;
  hasRequiredNamespace = 1;
  var forEach2 = requireForEach$1();
  function namespace2(obj, path) {
    if (!path) return obj;
    forEach2(path.split("."), function(key) {
      if (!obj[key]) {
        obj[key] = {};
      }
      obj = obj[key];
    });
    return obj;
  }
  namespace_1 = namespace2;
  return namespace_1;
}
var namespaceExports = requireNamespace();
const namespace = /* @__PURE__ */ getDefaultExportFromCjs(namespaceExports);
var omit_1;
var hasRequiredOmit;
function requireOmit() {
  if (hasRequiredOmit) return omit_1;
  hasRequiredOmit = 1;
  var slice2 = requireSlice();
  var contains2 = requireContains$4();
  function omit2(obj, var_keys) {
    var keys2 = typeof arguments[1] !== "string" ? arguments[1] : slice2(arguments, 1), out = {};
    for (var property in obj) {
      if (obj.hasOwnProperty(property) && !contains2(keys2, property)) {
        out[property] = obj[property];
      }
    }
    return out;
  }
  omit_1 = omit2;
  return omit_1;
}
var omitExports = requireOmit();
const omit = /* @__PURE__ */ getDefaultExportFromCjs(omitExports);
var pick_1;
var hasRequiredPick;
function requirePick() {
  if (hasRequiredPick) return pick_1;
  hasRequiredPick = 1;
  var slice2 = requireSlice();
  function pick2(obj, var_keys) {
    var keys2 = typeof arguments[1] !== "string" ? arguments[1] : slice2(arguments, 1), out = {}, i = 0, key;
    while (key = keys2[i++]) {
      out[key] = obj[key];
    }
    return out;
  }
  pick_1 = pick2;
  return pick_1;
}
var pickExports = requirePick();
const pick = /* @__PURE__ */ getDefaultExportFromCjs(pickExports);
var pluck_1;
var hasRequiredPluck;
function requirePluck() {
  if (hasRequiredPluck) return pluck_1;
  hasRequiredPluck = 1;
  var map2 = requireMap();
  var prop2 = requireProp();
  function pluck2(obj, propName) {
    return map2(obj, prop2(propName));
  }
  pluck_1 = pluck2;
  return pluck_1;
}
var pluckExports = requirePluck();
const pluck = /* @__PURE__ */ getDefaultExportFromCjs(pluckExports);
var reduceExports = requireReduce$1();
const reduce = /* @__PURE__ */ getDefaultExportFromCjs(reduceExports);
var reject_1;
var hasRequiredReject;
function requireReject() {
  if (hasRequiredReject) return reject_1;
  hasRequiredReject = 1;
  var filter2 = requireFilter();
  var makeIterator = requireMakeIterator_();
  function reject2(obj, callback, thisObj) {
    callback = makeIterator(callback, thisObj);
    return filter2(obj, function(value, index, obj2) {
      return !callback(value, index, obj2);
    }, thisObj);
  }
  reject_1 = reject2;
  return reject_1;
}
var rejectExports = requireReject();
const reject = /* @__PURE__ */ getDefaultExportFromCjs(rejectExports);
var valuesExports = requireValues();
const values = /* @__PURE__ */ getDefaultExportFromCjs(valuesExports);
var set_1;
var hasRequiredSet;
function requireSet() {
  if (hasRequiredSet) return set_1;
  hasRequiredSet = 1;
  var namespace2 = requireNamespace();
  function set2(obj, prop2, val) {
    var stringifiedProp = prop2.toString();
    if (stringifiedProp.includes("__proto__") || stringifiedProp.includes("prototype") || stringifiedProp.includes("constructor")) {
      return false;
    }
    var parts = /^(.+)\.(.+)$/.exec(stringifiedProp);
    if (parts) {
      namespace2(obj, parts[1])[parts[2]] = val;
    } else {
      obj[stringifiedProp] = val;
    }
  }
  set_1 = set2;
  return set_1;
}
var setExports = requireSet();
const set = /* @__PURE__ */ getDefaultExportFromCjs(setExports);
var sizeExports = requireSize$1();
const size = /* @__PURE__ */ getDefaultExportFromCjs(sizeExports);
var someExports = requireSome$1();
const some = /* @__PURE__ */ getDefaultExportFromCjs(someExports);
var unset_1;
var hasRequiredUnset;
function requireUnset() {
  if (hasRequiredUnset) return unset_1;
  hasRequiredUnset = 1;
  var has2 = requireHas();
  function unset2(obj, prop2) {
    if (has2(obj, prop2)) {
      var parts = prop2.split("."), last2 = parts.pop();
      while (prop2 = parts.shift()) {
        obj = obj[prop2];
      }
      return delete obj[last2];
    } else {
      return true;
    }
  }
  unset_1 = unset2;
  return unset_1;
}
var unsetExports = requireUnset();
const unset = /* @__PURE__ */ getDefaultExportFromCjs(unsetExports);
var result_1;
var hasRequiredResult;
function requireResult() {
  if (hasRequiredResult) return result_1;
  hasRequiredResult = 1;
  var isFunction2 = requireIsFunction();
  function result2(obj, prop2) {
    var property = obj[prop2];
    if (property === void 0) {
      return;
    }
    return isFunction2(property) ? property.call(obj) : property;
  }
  result_1 = result2;
  return result_1;
}
var resultExports = requireResult();
const result = /* @__PURE__ */ getDefaultExportFromCjs(resultExports);
var getQuery_1;
var hasRequiredGetQuery;
function requireGetQuery() {
  if (hasRequiredGetQuery) return getQuery_1;
  hasRequiredGetQuery = 1;
  function getQuery2(url) {
    var queryString = /\?[a-zA-Z0-9\=\&\%\$\-\_\.\+\!\*\'\(\)\,]+/.exec(url);
    return queryString ? decodeURIComponent(queryString[0].replace(/\+/g, " ")) : "";
  }
  getQuery_1 = getQuery2;
  return getQuery_1;
}
var contains_1$1;
var hasRequiredContains$1;
function requireContains$1() {
  if (hasRequiredContains$1) return contains_1$1;
  hasRequiredContains$1 = 1;
  var getQuery2 = requireGetQuery();
  function contains2(url, paramName) {
    var regex = new RegExp("(\\?|&)" + paramName + "=", "g");
    return regex.test(getQuery2(url));
  }
  contains_1$1 = contains2;
  return contains_1$1;
}
var containsExports$1 = requireContains$1();
const contains$1 = /* @__PURE__ */ getDefaultExportFromCjs(containsExports$1);
var typecast_1;
var hasRequiredTypecast;
function requireTypecast() {
  if (hasRequiredTypecast) return typecast_1;
  hasRequiredTypecast = 1;
  var UNDEF;
  function typecast2(val) {
    var r;
    if (val === null || val === "null") {
      r = null;
    } else if (val === "true") {
      r = true;
    } else if (val === "false") {
      r = false;
    } else if (val === UNDEF || val === "undefined") {
      r = UNDEF;
    } else if (val === "" || isNaN(val)) {
      r = val;
    } else {
      r = parseFloat(val);
    }
    return r;
  }
  typecast_1 = typecast2;
  return typecast_1;
}
var decode_1;
var hasRequiredDecode;
function requireDecode() {
  if (hasRequiredDecode) return decode_1;
  hasRequiredDecode = 1;
  var typecast2 = requireTypecast();
  var isArray2 = requireIsArray();
  var hasOwn2 = requireHasOwn();
  function decode2(queryStr, shouldTypecast) {
    var queryArr = (queryStr || "").replace("?", "").split("&"), i = -1, obj = {}, equalIndex, cur, pValue, pName;
    while (cur = queryArr[++i]) {
      equalIndex = cur.indexOf("=");
      pName = cur.substring(0, equalIndex);
      pValue = decodeURIComponent(cur.substring(equalIndex + 1));
      if (shouldTypecast !== false) {
        pValue = typecast2(pValue);
      }
      if (hasOwn2(obj, pName)) {
        if (isArray2(obj[pName])) {
          obj[pName].push(pValue);
        } else {
          obj[pName] = [obj[pName], pValue];
        }
      } else {
        obj[pName] = pValue;
      }
    }
    return obj;
  }
  decode_1 = decode2;
  return decode_1;
}
var decodeExports = requireDecode();
const decode = /* @__PURE__ */ getDefaultExportFromCjs(decodeExports);
var encode_1;
var hasRequiredEncode;
function requireEncode() {
  if (hasRequiredEncode) return encode_1;
  hasRequiredEncode = 1;
  var forOwn2 = requireForOwn();
  var isArray2 = requireIsArray();
  var forEach2 = requireForEach$1();
  function encode2(obj) {
    var query = [], arrValues, reg;
    forOwn2(obj, function(val, key) {
      if (isArray2(val)) {
        arrValues = key + "=";
        reg = new RegExp("&" + key + "+=$");
        forEach2(val, function(aValue) {
          arrValues += encodeURIComponent(aValue) + "&" + key + "=";
        });
        query.push(arrValues.replace(reg, ""));
      } else {
        query.push(key + "=" + encodeURIComponent(val));
      }
    });
    return query.length ? "?" + query.join("&") : "";
  }
  encode_1 = encode2;
  return encode_1;
}
var encodeExports = requireEncode();
const encode = /* @__PURE__ */ getDefaultExportFromCjs(encodeExports);
var getParam_1;
var hasRequiredGetParam;
function requireGetParam() {
  if (hasRequiredGetParam) return getParam_1;
  hasRequiredGetParam = 1;
  var typecast2 = requireTypecast();
  var getQuery2 = requireGetQuery();
  function getParam2(url, param, shouldTypecast) {
    var regexp = new RegExp("(\\?|&)" + param + "=([^&]*)"), result2 = regexp.exec(getQuery2(url)), val = result2 && result2[2] ? result2[2] : null;
    return shouldTypecast === false ? val : typecast2(val);
  }
  getParam_1 = getParam2;
  return getParam_1;
}
var getParamExports = requireGetParam();
const getParam = /* @__PURE__ */ getDefaultExportFromCjs(getParamExports);
var parse_1;
var hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1;
  var decode2 = requireDecode();
  var getQuery2 = requireGetQuery();
  function parse2(url, shouldTypecast) {
    return decode2(getQuery2(url), shouldTypecast);
  }
  parse_1 = parse2;
  return parse_1;
}
var parseExports = requireParse();
const parse = /* @__PURE__ */ getDefaultExportFromCjs(parseExports);
var getQueryExports = requireGetQuery();
const getQuery = /* @__PURE__ */ getDefaultExportFromCjs(getQueryExports);
var setParam_1;
var hasRequiredSetParam;
function requireSetParam() {
  if (hasRequiredSetParam) return setParam_1;
  hasRequiredSetParam = 1;
  function setParam2(url, paramName, value) {
    url = url || "";
    var re = new RegExp("(\\?|&)" + paramName + "=[^&]*");
    var param = paramName + "=" + encodeURIComponent(value);
    if (re.test(url)) {
      return url.replace(re, "$1" + param);
    } else {
      if (url.indexOf("?") === -1) {
        url += "?";
      }
      if (url.indexOf("=") !== -1) {
        url += "&";
      }
      return url + param;
    }
  }
  setParam_1 = setParam2;
  return setParam_1;
}
var setParamExports = requireSetParam();
const setParam = /* @__PURE__ */ getDefaultExportFromCjs(setParamExports);
var choice_1;
var hasRequiredChoice;
function requireChoice() {
  if (hasRequiredChoice) return choice_1;
  hasRequiredChoice = 1;
  var randInt2 = requireRandInt();
  var isArray2 = requireIsArray();
  function choice2(items) {
    var target = arguments.length === 1 && isArray2(items) ? items : arguments;
    return target[randInt2(0, target.length - 1)];
  }
  choice_1 = choice2;
  return choice_1;
}
var choiceExports = requireChoice();
const choice = /* @__PURE__ */ getDefaultExportFromCjs(choiceExports);
var randHex_1;
var hasRequiredRandHex;
function requireRandHex() {
  if (hasRequiredRandHex) return randHex_1;
  hasRequiredRandHex = 1;
  var choice2 = requireChoice();
  var _chars = "0123456789abcdef".split("");
  function randHex2(size2) {
    size2 = size2 && size2 > 0 ? size2 : 6;
    var str = "";
    while (size2--) {
      str += choice2(_chars);
    }
    return str;
  }
  randHex_1 = randHex2;
  return randHex_1;
}
var guid_1;
var hasRequiredGuid;
function requireGuid() {
  if (hasRequiredGuid) return guid_1;
  hasRequiredGuid = 1;
  var randHex2 = requireRandHex();
  var choice2 = requireChoice();
  function guid2() {
    return randHex2(8) + "-" + randHex2(4) + "-4" + randHex2(3) + "-" + // v4 UUID always contain chars [a,b,8,9] at this position
    choice2(8, 9, "a", "b") + randHex2(3) + "-" + randHex2(12);
  }
  guid_1 = guid2;
  return guid_1;
}
var guidExports = requireGuid();
const guid = /* @__PURE__ */ getDefaultExportFromCjs(guidExports);
var randExports = requireRand();
const rand = /* @__PURE__ */ getDefaultExportFromCjs(randExports);
var randBool_1;
var hasRequiredRandBool;
function requireRandBool() {
  if (hasRequiredRandBool) return randBool_1;
  hasRequiredRandBool = 1;
  var random2 = requireRandom();
  function randBool2() {
    return random2() >= 0.5;
  }
  randBool_1 = randBool2;
  return randBool_1;
}
var randBit$1;
var hasRequiredRandBit;
function requireRandBit() {
  if (hasRequiredRandBit) return randBit$1;
  hasRequiredRandBit = 1;
  var randBool2 = requireRandBool();
  function randomBit() {
    return randBool2() ? 1 : 0;
  }
  randBit$1 = randomBit;
  return randBit$1;
}
var randBitExports = requireRandBit();
const randBit = /* @__PURE__ */ getDefaultExportFromCjs(randBitExports);
var randBoolExports = requireRandBool();
const randBool = /* @__PURE__ */ getDefaultExportFromCjs(randBoolExports);
var randHexExports = requireRandHex();
const randHex = /* @__PURE__ */ getDefaultExportFromCjs(randHexExports);
var randIntExports = requireRandInt();
const randInt = /* @__PURE__ */ getDefaultExportFromCjs(randIntExports);
var randSign$1;
var hasRequiredRandSign;
function requireRandSign() {
  if (hasRequiredRandSign) return randSign$1;
  hasRequiredRandSign = 1;
  var randBool2 = requireRandBool();
  function randomSign() {
    return randBool2() ? 1 : -1;
  }
  randSign$1 = randomSign;
  return randSign$1;
}
var randSignExports = requireRandSign();
const randSign = /* @__PURE__ */ getDefaultExportFromCjs(randSignExports);
var randomExports = requireRandom();
const random = /* @__PURE__ */ getDefaultExportFromCjs(randomExports);
var randString$1;
var hasRequiredRandString;
function requireRandString() {
  if (hasRequiredRandString) return randString$1;
  hasRequiredRandString = 1;
  var isNumber2 = requireIsNumber();
  var isString2 = requireIsString();
  var randInt2 = requireRandInt();
  var defaultDictionary = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  function randomString(length, dictionary) {
    if (!isNumber2(length) || length <= 0) {
      length = 8;
    }
    if (!isString2(dictionary) || dictionary.length < 1) {
      dictionary = defaultDictionary;
    }
    var result2 = "", domain = dictionary.length - 1;
    while (length--) {
      result2 += dictionary[randInt2(0, domain)];
    }
    return result2;
  }
  randString$1 = randomString;
  return randString$1;
}
var randStringExports = requireRandString();
const randString = /* @__PURE__ */ getDefaultExportFromCjs(randStringExports);
var replaceAccents_1;
var hasRequiredReplaceAccents;
function requireReplaceAccents() {
  if (hasRequiredReplaceAccents) return replaceAccents_1;
  hasRequiredReplaceAccents = 1;
  var toString2 = requireToString();
  function replaceAccents2(str) {
    str = toString2(str);
    if (str.search(/[\xC0-\xFF]/g) > -1) {
      str = str.replace(/[\xC0-\xC5]/g, "A").replace(/[\xC6]/g, "AE").replace(/[\xC7]/g, "C").replace(/[\xC8-\xCB]/g, "E").replace(/[\xCC-\xCF]/g, "I").replace(/[\xD0]/g, "D").replace(/[\xD1]/g, "N").replace(/[\xD2-\xD6\xD8]/g, "O").replace(/[\xD9-\xDC]/g, "U").replace(/[\xDD]/g, "Y").replace(/[\xDE]/g, "P").replace(/[\xE0-\xE5]/g, "a").replace(/[\xE6]/g, "ae").replace(/[\xE7]/g, "c").replace(/[\xE8-\xEB]/g, "e").replace(/[\xEC-\xEF]/g, "i").replace(/[\xF1]/g, "n").replace(/[\xF2-\xF6\xF8]/g, "o").replace(/[\xF9-\xFC]/g, "u").replace(/[\xFE]/g, "p").replace(/[\xFD\xFF]/g, "y");
    }
    return str;
  }
  replaceAccents_1 = replaceAccents2;
  return replaceAccents_1;
}
var removeNonWord_1;
var hasRequiredRemoveNonWord;
function requireRemoveNonWord() {
  if (hasRequiredRemoveNonWord) return removeNonWord_1;
  hasRequiredRemoveNonWord = 1;
  var toString2 = requireToString();
  var PATTERN = /[^\x20\x2D0-9A-Z\x5Fa-z\xC0-\xD6\xD8-\xF6\xF8-\xFF]/g;
  function removeNonWord2(str) {
    str = toString2(str);
    return str.replace(PATTERN, "");
  }
  removeNonWord_1 = removeNonWord2;
  return removeNonWord_1;
}
var upperCase_1;
var hasRequiredUpperCase;
function requireUpperCase() {
  if (hasRequiredUpperCase) return upperCase_1;
  hasRequiredUpperCase = 1;
  var toString2 = requireToString();
  function upperCase2(str) {
    str = toString2(str);
    return str.toUpperCase();
  }
  upperCase_1 = upperCase2;
  return upperCase_1;
}
var lowerCase_1;
var hasRequiredLowerCase;
function requireLowerCase() {
  if (hasRequiredLowerCase) return lowerCase_1;
  hasRequiredLowerCase = 1;
  var toString2 = requireToString();
  function lowerCase2(str) {
    str = toString2(str);
    return str.toLowerCase();
  }
  lowerCase_1 = lowerCase2;
  return lowerCase_1;
}
var camelCase_1;
var hasRequiredCamelCase;
function requireCamelCase() {
  if (hasRequiredCamelCase) return camelCase_1;
  hasRequiredCamelCase = 1;
  var toString2 = requireToString();
  var replaceAccents2 = requireReplaceAccents();
  var removeNonWord2 = requireRemoveNonWord();
  var upperCase2 = requireUpperCase();
  var lowerCase2 = requireLowerCase();
  function camelCase2(str) {
    str = toString2(str);
    str = replaceAccents2(str);
    str = removeNonWord2(str).replace(/[\-_]/g, " ");
    if (/[a-z]/.test(str) && /^|\s[A-Z]+\s|$/.test(str)) {
      str = str.replace(/\s(\w+)/g, function(word, m) {
        return /^[A-Z]+$/.test(m) ? word : lowerCase2(word);
      });
    } else if (/\s/.test(str)) {
      str = lowerCase2(str);
    }
    return str.replace(/\s[a-z]/g, upperCase2).replace(/^\s*[A-Z]+/g, lowerCase2).replace(/\s+/g, "");
  }
  camelCase_1 = camelCase2;
  return camelCase_1;
}
var camelCaseExports = requireCamelCase();
const camelCase = /* @__PURE__ */ getDefaultExportFromCjs(camelCaseExports);
var contains_1;
var hasRequiredContains;
function requireContains() {
  if (hasRequiredContains) return contains_1;
  hasRequiredContains = 1;
  var toString2 = requireToString();
  function contains2(str, substring, fromIndex) {
    str = toString2(str);
    substring = toString2(substring);
    return str.indexOf(substring, fromIndex) !== -1;
  }
  contains_1 = contains2;
  return contains_1;
}
var containsExports = requireContains();
const contains = /* @__PURE__ */ getDefaultExportFromCjs(containsExports);
var WHITE_SPACES$1;
var hasRequiredWHITE_SPACES;
function requireWHITE_SPACES() {
  if (hasRequiredWHITE_SPACES) return WHITE_SPACES$1;
  hasRequiredWHITE_SPACES = 1;
  WHITE_SPACES$1 = [
    " ",
    "\n",
    "\r",
    "	",
    "\f",
    "\v",
    " ",
    " ",
    "᠎",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    "\u2028",
    "\u2029",
    " ",
    " ",
    "　"
  ];
  return WHITE_SPACES$1;
}
var ltrim_1;
var hasRequiredLtrim;
function requireLtrim() {
  if (hasRequiredLtrim) return ltrim_1;
  hasRequiredLtrim = 1;
  var toString2 = requireToString();
  var WHITE_SPACES2 = requireWHITE_SPACES();
  function ltrim2(str, chars) {
    str = toString2(str);
    chars = chars || WHITE_SPACES2;
    var start = 0, len = str.length, charLen = chars.length, found = true, i, c;
    while (found && start < len) {
      found = false;
      i = -1;
      c = str.charAt(start);
      while (++i < charLen) {
        if (c === chars[i]) {
          found = true;
          start++;
          break;
        }
      }
    }
    return start >= len ? "" : str.substr(start, len);
  }
  ltrim_1 = ltrim2;
  return ltrim_1;
}
var rtrim_1;
var hasRequiredRtrim;
function requireRtrim() {
  if (hasRequiredRtrim) return rtrim_1;
  hasRequiredRtrim = 1;
  var toString2 = requireToString();
  var WHITE_SPACES2 = requireWHITE_SPACES();
  function rtrim2(str, chars) {
    str = toString2(str);
    chars = chars || WHITE_SPACES2;
    var end = str.length - 1, charLen = chars.length, found = true, i, c;
    while (found && end >= 0) {
      found = false;
      i = -1;
      c = str.charAt(end);
      while (++i < charLen) {
        if (c === chars[i]) {
          found = true;
          end--;
          break;
        }
      }
    }
    return end >= 0 ? str.substring(0, end + 1) : "";
  }
  rtrim_1 = rtrim2;
  return rtrim_1;
}
var trim_1;
var hasRequiredTrim;
function requireTrim() {
  if (hasRequiredTrim) return trim_1;
  hasRequiredTrim = 1;
  var toString2 = requireToString();
  var WHITE_SPACES2 = requireWHITE_SPACES();
  var ltrim2 = requireLtrim();
  var rtrim2 = requireRtrim();
  function trim2(str, chars) {
    str = toString2(str);
    chars = chars || WHITE_SPACES2;
    return ltrim2(rtrim2(str, chars), chars);
  }
  trim_1 = trim2;
  return trim_1;
}
var truncate_1;
var hasRequiredTruncate;
function requireTruncate() {
  if (hasRequiredTruncate) return truncate_1;
  hasRequiredTruncate = 1;
  var toString2 = requireToString();
  var trim2 = requireTrim();
  function truncate2(str, maxChars, append2, onlyFullWords) {
    str = toString2(str);
    append2 = append2 || "...";
    maxChars = onlyFullWords ? maxChars + 1 : maxChars;
    str = trim2(str);
    if (str.length <= maxChars) {
      return str;
    }
    str = str.substr(0, maxChars - append2.length);
    str = onlyFullWords ? str.substr(0, str.lastIndexOf(" ")) : trim2(str);
    return str + append2;
  }
  truncate_1 = truncate2;
  return truncate_1;
}
var crop_1;
var hasRequiredCrop;
function requireCrop() {
  if (hasRequiredCrop) return crop_1;
  hasRequiredCrop = 1;
  var toString2 = requireToString();
  var truncate2 = requireTruncate();
  function crop2(str, maxChars, append2) {
    str = toString2(str);
    return truncate2(str, maxChars, append2, true);
  }
  crop_1 = crop2;
  return crop_1;
}
var cropExports = requireCrop();
const crop = /* @__PURE__ */ getDefaultExportFromCjs(cropExports);
var endsWith_1;
var hasRequiredEndsWith;
function requireEndsWith() {
  if (hasRequiredEndsWith) return endsWith_1;
  hasRequiredEndsWith = 1;
  var toString2 = requireToString();
  function endsWith2(str, suffix) {
    str = toString2(str);
    suffix = toString2(suffix);
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  }
  endsWith_1 = endsWith2;
  return endsWith_1;
}
var endsWithExports = requireEndsWith();
const endsWith = /* @__PURE__ */ getDefaultExportFromCjs(endsWithExports);
var escapeHtml_1;
var hasRequiredEscapeHtml;
function requireEscapeHtml() {
  if (hasRequiredEscapeHtml) return escapeHtml_1;
  hasRequiredEscapeHtml = 1;
  var toString2 = requireToString();
  function escapeHtml2(str) {
    str = toString2(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    return str;
  }
  escapeHtml_1 = escapeHtml2;
  return escapeHtml_1;
}
var escapeHtmlExports = requireEscapeHtml();
const escapeHtml = /* @__PURE__ */ getDefaultExportFromCjs(escapeHtmlExports);
var escapeRegExp_1;
var hasRequiredEscapeRegExp;
function requireEscapeRegExp() {
  if (hasRequiredEscapeRegExp) return escapeRegExp_1;
  hasRequiredEscapeRegExp = 1;
  var toString2 = requireToString();
  function escapeRegExp2(str) {
    return toString2(str).replace(/\W/g, "\\$&");
  }
  escapeRegExp_1 = escapeRegExp2;
  return escapeRegExp_1;
}
var escapeRegExpExports = requireEscapeRegExp();
const escapeRegExp = /* @__PURE__ */ getDefaultExportFromCjs(escapeRegExpExports);
var escapeUnicode_1;
var hasRequiredEscapeUnicode;
function requireEscapeUnicode() {
  if (hasRequiredEscapeUnicode) return escapeUnicode_1;
  hasRequiredEscapeUnicode = 1;
  var toString2 = requireToString();
  function escapeUnicode2(str, shouldEscapePrintable) {
    str = toString2(str);
    return str.replace(/[\s\S]/g, function(ch) {
      if (!shouldEscapePrintable && /[\x20-\x7E]/.test(ch)) {
        return ch;
      }
      return "\\u" + ("000" + ch.charCodeAt(0).toString(16)).slice(-4);
    });
  }
  escapeUnicode_1 = escapeUnicode2;
  return escapeUnicode_1;
}
var escapeUnicodeExports = requireEscapeUnicode();
const escapeUnicode = /* @__PURE__ */ getDefaultExportFromCjs(escapeUnicodeExports);
var slugify_1;
var hasRequiredSlugify;
function requireSlugify() {
  if (hasRequiredSlugify) return slugify_1;
  hasRequiredSlugify = 1;
  var toString2 = requireToString();
  var replaceAccents2 = requireReplaceAccents();
  var removeNonWord2 = requireRemoveNonWord();
  var trim2 = requireTrim();
  function slugify2(str, delimiter) {
    str = toString2(str);
    if (delimiter == null) {
      delimiter = "-";
    }
    str = replaceAccents2(str);
    str = removeNonWord2(str);
    str = trim2(str).replace(/ +/g, delimiter).toLowerCase();
    return str;
  }
  slugify_1 = slugify2;
  return slugify_1;
}
var unCamelCase_1;
var hasRequiredUnCamelCase;
function requireUnCamelCase() {
  if (hasRequiredUnCamelCase) return unCamelCase_1;
  hasRequiredUnCamelCase = 1;
  var toString2 = requireToString();
  var CAMEL_CASE_BORDER = /([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g;
  function unCamelCase2(str, delimiter) {
    if (delimiter == null) {
      delimiter = " ";
    }
    function join2(str2, c1, c2) {
      return c1 + delimiter + c2;
    }
    str = toString2(str);
    str = str.replace(CAMEL_CASE_BORDER, join2);
    str = str.toLowerCase();
    return str;
  }
  unCamelCase_1 = unCamelCase2;
  return unCamelCase_1;
}
var hyphenate_1;
var hasRequiredHyphenate;
function requireHyphenate() {
  if (hasRequiredHyphenate) return hyphenate_1;
  hasRequiredHyphenate = 1;
  var toString2 = requireToString();
  var slugify2 = requireSlugify();
  var unCamelCase2 = requireUnCamelCase();
  function hyphenate2(str) {
    str = toString2(str);
    str = unCamelCase2(str);
    return slugify2(str, "-");
  }
  hyphenate_1 = hyphenate2;
  return hyphenate_1;
}
var hyphenateExports = requireHyphenate();
const hyphenate = /* @__PURE__ */ getDefaultExportFromCjs(hyphenateExports);
var insert_1;
var hasRequiredInsert;
function requireInsert() {
  if (hasRequiredInsert) return insert_1;
  hasRequiredInsert = 1;
  var clamp2 = requireClamp();
  var toString2 = requireToString();
  function insert2(string, index, partial2) {
    string = toString2(string);
    if (index < 0) {
      index = string.length + index;
    }
    index = clamp2(index, 0, string.length);
    return string.substr(0, index) + partial2 + string.substr(index);
  }
  insert_1 = insert2;
  return insert_1;
}
var insertExports = requireInsert();
const insert = /* @__PURE__ */ getDefaultExportFromCjs(insertExports);
var interpolate_1;
var hasRequiredInterpolate;
function requireInterpolate() {
  if (hasRequiredInterpolate) return interpolate_1;
  hasRequiredInterpolate = 1;
  var toString2 = requireToString();
  var get2 = requireGet();
  var stache = /\{\{([^\}]+)\}\}/g;
  function interpolate2(template, replacements, syntax) {
    template = toString2(template);
    var replaceFn = function(match2, prop2) {
      return toString2(get2(replacements, prop2));
    };
    return template.replace(syntax || stache, replaceFn);
  }
  interpolate_1 = interpolate2;
  return interpolate_1;
}
var interpolateExports = requireInterpolate();
const interpolate = /* @__PURE__ */ getDefaultExportFromCjs(interpolateExports);
var lowerCaseExports = requireLowerCase();
const lowerCase = /* @__PURE__ */ getDefaultExportFromCjs(lowerCaseExports);
var lpadExports = requireLpad();
const lpad = /* @__PURE__ */ getDefaultExportFromCjs(lpadExports);
var ltrimExports = requireLtrim();
const ltrim = /* @__PURE__ */ getDefaultExportFromCjs(ltrimExports);
var makePath_1;
var hasRequiredMakePath;
function requireMakePath() {
  if (hasRequiredMakePath) return makePath_1;
  hasRequiredMakePath = 1;
  var join2 = requireJoin();
  var slice2 = requireSlice();
  function makePath2(var_args) {
    var result2 = join2(slice2(arguments), "/");
    return result2.replace(/([^:\/]|^)\/{2,}/g, "$1/");
  }
  makePath_1 = makePath2;
  return makePath_1;
}
var makePathExports = requireMakePath();
const makePath = /* @__PURE__ */ getDefaultExportFromCjs(makePathExports);
var normalizeLineBreaks_1;
var hasRequiredNormalizeLineBreaks;
function requireNormalizeLineBreaks() {
  if (hasRequiredNormalizeLineBreaks) return normalizeLineBreaks_1;
  hasRequiredNormalizeLineBreaks = 1;
  var toString2 = requireToString();
  function normalizeLineBreaks2(str, lineEnd) {
    str = toString2(str);
    lineEnd = lineEnd || "\n";
    return str.replace(/\r\n/g, lineEnd).replace(/\r/g, lineEnd).replace(/\n/g, lineEnd);
  }
  normalizeLineBreaks_1 = normalizeLineBreaks2;
  return normalizeLineBreaks_1;
}
var normalizeLineBreaksExports = requireNormalizeLineBreaks();
const normalizeLineBreaks = /* @__PURE__ */ getDefaultExportFromCjs(normalizeLineBreaksExports);
var pascalCase_1;
var hasRequiredPascalCase;
function requirePascalCase() {
  if (hasRequiredPascalCase) return pascalCase_1;
  hasRequiredPascalCase = 1;
  var toString2 = requireToString();
  var camelCase2 = requireCamelCase();
  var upperCase2 = requireUpperCase();
  function pascalCase2(str) {
    str = toString2(str);
    return camelCase2(str).replace(/^[a-z]/, upperCase2);
  }
  pascalCase_1 = pascalCase2;
  return pascalCase_1;
}
var pascalCaseExports = requirePascalCase();
const pascalCase = /* @__PURE__ */ getDefaultExportFromCjs(pascalCaseExports);
var properCase_1;
var hasRequiredProperCase;
function requireProperCase() {
  if (hasRequiredProperCase) return properCase_1;
  hasRequiredProperCase = 1;
  var toString2 = requireToString();
  var lowerCase2 = requireLowerCase();
  var upperCase2 = requireUpperCase();
  function properCase2(str) {
    str = toString2(str);
    return lowerCase2(str).replace(/^\w|\s\w/g, upperCase2);
  }
  properCase_1 = properCase2;
  return properCase_1;
}
var properCaseExports = requireProperCase();
const properCase = /* @__PURE__ */ getDefaultExportFromCjs(properCaseExports);
var removeNonASCII_1;
var hasRequiredRemoveNonASCII;
function requireRemoveNonASCII() {
  if (hasRequiredRemoveNonASCII) return removeNonASCII_1;
  hasRequiredRemoveNonASCII = 1;
  var toString2 = requireToString();
  function removeNonASCII2(str) {
    str = toString2(str);
    return str.replace(/[^\x20-\x7E]/g, "");
  }
  removeNonASCII_1 = removeNonASCII2;
  return removeNonASCII_1;
}
var removeNonASCIIExports = requireRemoveNonASCII();
const removeNonASCII = /* @__PURE__ */ getDefaultExportFromCjs(removeNonASCIIExports);
var removeNonWordExports = requireRemoveNonWord();
const removeNonWord = /* @__PURE__ */ getDefaultExportFromCjs(removeNonWordExports);
var repeatExports = requireRepeat();
const repeat = /* @__PURE__ */ getDefaultExportFromCjs(repeatExports);
var replace_1;
var hasRequiredReplace;
function requireReplace() {
  if (hasRequiredReplace) return replace_1;
  hasRequiredReplace = 1;
  var toString2 = requireToString();
  var toArray2 = requireToArray();
  function replace2(str, search, replacements) {
    str = toString2(str);
    search = toArray2(search);
    replacements = toArray2(replacements);
    var searchLength = search.length, replacementsLength = replacements.length;
    if (replacementsLength !== 1 && searchLength !== replacementsLength) {
      throw new Error("Unequal number of searches and replacements");
    }
    var i = -1;
    while (++i < searchLength) {
      str = str.replace(
        search[i],
        replacements[replacementsLength === 1 ? 0 : i]
      );
    }
    return str;
  }
  replace_1 = replace2;
  return replace_1;
}
var replaceExports = requireReplace();
const replace = /* @__PURE__ */ getDefaultExportFromCjs(replaceExports);
var replaceAccentsExports = requireReplaceAccents();
const replaceAccents = /* @__PURE__ */ getDefaultExportFromCjs(replaceAccentsExports);
var rpad_1;
var hasRequiredRpad;
function requireRpad() {
  if (hasRequiredRpad) return rpad_1;
  hasRequiredRpad = 1;
  var toString2 = requireToString();
  var repeat2 = requireRepeat();
  function rpad2(str, minLen, ch) {
    str = toString2(str);
    ch = ch || " ";
    return str.length < minLen ? str + repeat2(ch, minLen - str.length) : str;
  }
  rpad_1 = rpad2;
  return rpad_1;
}
var rpadExports = requireRpad();
const rpad = /* @__PURE__ */ getDefaultExportFromCjs(rpadExports);
var rtrimExports = requireRtrim();
const rtrim = /* @__PURE__ */ getDefaultExportFromCjs(rtrimExports);
var sentenceCase_1;
var hasRequiredSentenceCase;
function requireSentenceCase() {
  if (hasRequiredSentenceCase) return sentenceCase_1;
  hasRequiredSentenceCase = 1;
  var toString2 = requireToString();
  var lowerCase2 = requireLowerCase();
  var upperCase2 = requireUpperCase();
  function sentenceCase2(str) {
    str = toString2(str);
    return lowerCase2(str).replace(/(^\w)|\.\s+(\w)/gm, upperCase2);
  }
  sentenceCase_1 = sentenceCase2;
  return sentenceCase_1;
}
var sentenceCaseExports = requireSentenceCase();
const sentenceCase = /* @__PURE__ */ getDefaultExportFromCjs(sentenceCaseExports);
var stripHtmlTags_1;
var hasRequiredStripHtmlTags;
function requireStripHtmlTags() {
  if (hasRequiredStripHtmlTags) return stripHtmlTags_1;
  hasRequiredStripHtmlTags = 1;
  var toString2 = requireToString();
  function stripHtmlTags2(str) {
    str = toString2(str);
    return str.replace(/<[^>]*>/g, "");
  }
  stripHtmlTags_1 = stripHtmlTags2;
  return stripHtmlTags_1;
}
var stripHtmlTagsExports = requireStripHtmlTags();
const stripHtmlTags = /* @__PURE__ */ getDefaultExportFromCjs(stripHtmlTagsExports);
var startsWith_1;
var hasRequiredStartsWith;
function requireStartsWith() {
  if (hasRequiredStartsWith) return startsWith_1;
  hasRequiredStartsWith = 1;
  var toString2 = requireToString();
  function startsWith2(str, prefix) {
    str = toString2(str);
    prefix = toString2(prefix);
    return str.indexOf(prefix) === 0;
  }
  startsWith_1 = startsWith2;
  return startsWith_1;
}
var startsWithExports = requireStartsWith();
const startsWith = /* @__PURE__ */ getDefaultExportFromCjs(startsWithExports);
var slugifyExports = requireSlugify();
const slugify = /* @__PURE__ */ getDefaultExportFromCjs(slugifyExports);
var trimExports = requireTrim();
const trim = /* @__PURE__ */ getDefaultExportFromCjs(trimExports);
var truncateExports = requireTruncate();
const truncate = /* @__PURE__ */ getDefaultExportFromCjs(truncateExports);
var typecastExports = requireTypecast();
const typecast = /* @__PURE__ */ getDefaultExportFromCjs(typecastExports);
var unCamelCaseExports = requireUnCamelCase();
const unCamelCase = /* @__PURE__ */ getDefaultExportFromCjs(unCamelCaseExports);
var underscore_1;
var hasRequiredUnderscore;
function requireUnderscore() {
  if (hasRequiredUnderscore) return underscore_1;
  hasRequiredUnderscore = 1;
  var toString2 = requireToString();
  var slugify2 = requireSlugify();
  var unCamelCase2 = requireUnCamelCase();
  function underscore2(str) {
    str = toString2(str);
    str = unCamelCase2(str);
    return slugify2(str, "_");
  }
  underscore_1 = underscore2;
  return underscore_1;
}
var underscoreExports = requireUnderscore();
const underscore = /* @__PURE__ */ getDefaultExportFromCjs(underscoreExports);
var unescapeHtml_1;
var hasRequiredUnescapeHtml;
function requireUnescapeHtml() {
  if (hasRequiredUnescapeHtml) return unescapeHtml_1;
  hasRequiredUnescapeHtml = 1;
  var toString2 = requireToString();
  function unescapeHtml2(str) {
    str = toString2(str).replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#0*39;/g, "'").replace(/&quot;/g, '"');
    return str;
  }
  unescapeHtml_1 = unescapeHtml2;
  return unescapeHtml_1;
}
var unescapeHtmlExports = requireUnescapeHtml();
const unescapeHtml = /* @__PURE__ */ getDefaultExportFromCjs(unescapeHtmlExports);
var unescapeUnicode_1;
var hasRequiredUnescapeUnicode;
function requireUnescapeUnicode() {
  if (hasRequiredUnescapeUnicode) return unescapeUnicode_1;
  hasRequiredUnescapeUnicode = 1;
  var toString2 = requireToString();
  function unescapeUnicode2(str) {
    str = toString2(str);
    return str.replace(/\\u[0-9a-f]{4}/g, function(ch) {
      var code = parseInt(ch.slice(2), 16);
      return String.fromCharCode(code);
    });
  }
  unescapeUnicode_1 = unescapeUnicode2;
  return unescapeUnicode_1;
}
var unescapeUnicodeExports = requireUnescapeUnicode();
const unescapeUnicode = /* @__PURE__ */ getDefaultExportFromCjs(unescapeUnicodeExports);
var unhyphenate_1;
var hasRequiredUnhyphenate;
function requireUnhyphenate() {
  if (hasRequiredUnhyphenate) return unhyphenate_1;
  hasRequiredUnhyphenate = 1;
  var toString2 = requireToString();
  function unhyphenate2(str) {
    str = toString2(str);
    return str.replace(/(\w)(-)(\w)/g, "$1 $3");
  }
  unhyphenate_1 = unhyphenate2;
  return unhyphenate_1;
}
var unhyphenateExports = requireUnhyphenate();
const unhyphenate = /* @__PURE__ */ getDefaultExportFromCjs(unhyphenateExports);
var upperCaseExports = requireUpperCase();
const upperCase = /* @__PURE__ */ getDefaultExportFromCjs(upperCaseExports);
var WHITE_SPACESExports = requireWHITE_SPACES();
const WHITE_SPACES = /* @__PURE__ */ getDefaultExportFromCjs(WHITE_SPACESExports);
var convertExports = requireConvert();
const convert = /* @__PURE__ */ getDefaultExportFromCjs(convertExports);
var nowExports = requireNow();
const now = /* @__PURE__ */ getDefaultExportFromCjs(nowExports);
var parseMs_1;
var hasRequiredParseMs;
function requireParseMs() {
  if (hasRequiredParseMs) return parseMs_1;
  hasRequiredParseMs = 1;
  var countSteps2 = requireCountSteps();
  function parseMs2(ms) {
    return {
      milliseconds: countSteps2(ms, 1, 1e3),
      seconds: countSteps2(ms, 1e3, 60),
      minutes: countSteps2(ms, 6e4, 60),
      hours: countSteps2(ms, 36e5, 24),
      days: countSteps2(ms, 864e5)
    };
  }
  parseMs_1 = parseMs2;
  return parseMs_1;
}
var parseMsExports = requireParseMs();
const parseMs = /* @__PURE__ */ getDefaultExportFromCjs(parseMsExports);
var toTimeString_1;
var hasRequiredToTimeString;
function requireToTimeString() {
  if (hasRequiredToTimeString) return toTimeString_1;
  hasRequiredToTimeString = 1;
  var countSteps2 = requireCountSteps();
  var pad2 = requirePad();
  var HOUR = 36e5, MINUTE = 6e4, SECOND = 1e3;
  function toTimeString2(ms) {
    var h = ms < HOUR ? 0 : countSteps2(ms, HOUR), m = ms < MINUTE ? 0 : countSteps2(ms, MINUTE, 60), s2 = ms < SECOND ? 0 : countSteps2(ms, SECOND, 60), str = "";
    str += h ? h + ":" : "";
    str += pad2(m, 2) + ":";
    str += pad2(s2, 2);
    return str;
  }
  toTimeString_1 = toTimeString2;
  return toTimeString_1;
}
var toTimeStringExports = requireToTimeString();
const toTimeString = /* @__PURE__ */ getDefaultExportFromCjs(toTimeStringExports);
export {
  BlobUtils,
  DateTime,
  Duration,
  FixedOffsetZone,
  GLOBAL,
  IANAZone,
  Info,
  Interval,
  InvalidZone,
  MAX_INT,
  MAX_SAFE_INTEGER,
  MAX_UINT,
  MIN_INT,
  Settings,
  SystemZone,
  VERSION,
  WHITE_SPACES,
  Zone,
  abbreviate,
  after,
  append,
  awaitDelay,
  bind,
  bindAll,
  camelCase,
  ceil,
  choice,
  clamp,
  clone,
  collect,
  contains$3 as collectionContains,
  every$1 as collectionEvery,
  filter$2 as collectionFilter,
  find$1 as collectionFind,
  forEach as collectionForEach,
  map$3 as collectionMap,
  max$1 as collectionMax,
  min$1 as collectionMin,
  pluck$1 as collectionPluck,
  reduce$1 as collectionReduce,
  reject$1 as collectionReject,
  some$1 as collectionSome,
  combine,
  compact,
  compose,
  constant,
  contains$5 as contains,
  convert,
  countSteps,
  createObject,
  crop,
  ctorApply,
  currencyFormat,
  dayOfTheYear,
  debounce,
  decode,
  deepClone,
  deepEquals,
  deepFillIn,
  deepMatches,
  deepMixIn,
  defaults,
  diff$1 as diff,
  difference,
  encode,
  endOfCurrentMonth,
  endsWith,
  enforcePrecision,
  equals$1 as equals,
  escapeHtml,
  escapeRegExp,
  escapeUnicode,
  every$3 as every,
  fillIn,
  filter$3 as filter,
  find$3 as find,
  findIndex,
  findLast,
  findLastIndex,
  flatten,
  floor,
  forEach$2 as forEach,
  forIn,
  forOwn,
  formatCurrencyUSD,
  formatDate,
  formatDateTime,
  formatTime,
  fromISO,
  func,
  functions,
  get,
  getParam,
  getQuery,
  groupBy,
  guid,
  has,
  hasOwn,
  hyphenate,
  identity,
  inRange,
  indexOf,
  inheritPrototype,
  insert$1 as insert,
  interpolate,
  intersection,
  invoke,
  is,
  isArray,
  isBoolean,
  isDate,
  isEmpty,
  isFinite,
  isFunction,
  isInteger,
  isKind,
  isLeapYear$1 as isLeapYear,
  isNaN$1 as isNaN,
  isNear,
  isNull,
  isNumber,
  isObject,
  isPlainObject,
  isRegExp,
  isSame,
  isString,
  isUndefined,
  isnt,
  join,
  keys,
  kindOf,
  isNaN$2 as langIsNaN,
  last,
  lastIndexOf,
  lerp,
  loop,
  lowerCase,
  lpad,
  ltrim,
  makePath,
  map$4 as map,
  matches,
  map$2 as mathMap,
  max$3 as max,
  merge,
  min$3 as min,
  mixIn,
  namespace,
  norm,
  normalizeLineBreaks,
  now,
  nth,
  contains$2 as objectContains,
  equals as objectEquals,
  every as objectEvery,
  filter as objectFilter,
  find as objectFind,
  map as objectMap,
  max as objectMax,
  min as objectMin,
  pick as objectPick,
  pluck as objectPluck,
  reduce as objectReduce,
  reject as objectReject,
  size as objectSize,
  some as objectSome,
  omit,
  ordinal,
  pad,
  parse,
  parseAndFormatDate,
  parseAndFormatDateTime,
  parseAndFormatTime,
  parseIso,
  parseMs,
  partial,
  pascalCase,
  pick$2 as pick,
  pluck$2 as pluck,
  prop,
  properCase,
  quarter,
  contains$1 as queryStringContains,
  rand,
  randBit,
  randBool,
  randHex,
  randInt,
  randSign,
  randString,
  random,
  range,
  reduce$3 as reduce,
  reduceRight,
  reject$2 as reject,
  remove,
  removeAll,
  removeNonASCII,
  removeNonWord,
  repeat,
  replace,
  replaceAccents,
  result,
  rol,
  ror,
  round,
  rpad,
  rtrim,
  sentenceCase,
  series,
  set,
  setParam,
  shuffle,
  sign,
  size$1 as size,
  slice,
  slugify,
  some$3 as some,
  sort,
  sortBy,
  split,
  startOf,
  startOfCurrentMonth,
  startsWith,
  strftime,
  contains as stringContains,
  insert as stringInsert,
  stripHtmlTags,
  take,
  throttle,
  timeZones,
  timeout,
  times,
  timezoneAbbr,
  timezoneOffset,
  toArray,
  toDateTime,
  toISO,
  toInt,
  toLookup,
  toNumber,
  toString,
  toTimeString,
  toUInt,
  toUInt31,
  totalDaysInMonth,
  totalDaysInYear,
  trim,
  truncate,
  typecast,
  unCamelCase,
  underscore,
  unescapeHtml,
  unescapeUnicode,
  unhyphenate,
  union,
  unique,
  unset,
  upperCase,
  values,
  weekOfTheYear,
  wrap,
  xor,
  zip
};
//# sourceMappingURL=index.js.map
